import { Injectable } from '@angular/core';
import { ICompetition } from 'src/app/models/sportHierarchy/competition.iterface';
import { IRegion } from 'src/app/models/sportHierarchy/region';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { ICompetitionTO } from 'src/app/models/sportHierarchy/transportObjects/competitionTO.interface';
import { IRegionTO } from 'src/app/models/sportHierarchy/transportObjects/regionTO.interface';
import { ISportTO } from 'src/app/models/sportHierarchy/transportObjects/sportTO.interface';
import { TicketType, FreeBetProcessingType, BetTypeSelectionSBVSelectionType, OddsValidationMode, RequestSource, EventType, SBVDisplayType, TicketStatus, TicketPlayType, TypeOfPlaceBetTicket, HomeAway, SpecialOfferType, GroupTypeList } from 'src/app/models/enums';
import { IBetTypeSelection } from 'src/app/models/betType/betTypeSelection.interface';
import { IBetTypeSelectionTO } from 'src/app/models/betType/transportObjects/betTypeSelectionTO.interface';
import { IBetTypeOutcome } from 'src/app/models/betType/betTypeOutcome.interface';
import { IBetTypeOutcomeTO } from 'src/app/models/betType/transportObjects/betTypeOutcomeTO.interface';
import { IBetTypeTO } from 'src/app/models/betType/transportObjects/betTypeTO.interface';
import { IBetType } from 'src/app/models/betType/betType.interface';
import { IBetTypeShowTypeTO } from 'src/app/models/betType/transportObjects/betTypeShowTypeTO.interface';
import { IBetTypeShowType } from 'src/app/models/betType/betTypeShowType.interface';
import { IBetTypesShowTypesTO } from 'src/app/models/betType/transportObjects/betTypeShowTypesTO.interface';
import { IBetOutcomeTO } from 'src/app/models/bet/transportObjects/betOutcomeTO.interface';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { IBet } from 'src/app/models/bet/bet';
import { IBetTO } from 'src/app/models/bet/transportObjects/betTO.interface';
import { IEventLiveResultInfoTO } from 'src/app/models/event/transportObjects/eventLiveResultInfoTO.interface';
import { IEventLiveResultInfo } from 'src/app/models/event/eventLiveResultInfo.interface';
import { IEventTO } from 'src/app/models/event/transportObjects/eventTO.interface';
import { EventVM } from 'src/app/models/event/event';
import { IBetTypeGroupingTemplateItemTO } from 'src/app/models/betType/transportObjects/betTypeGroupingTemplateItemTO.interface';
import { IBetTypeGroupingTemplateItem } from 'src/app/models/betType/betTypeGroupingTemplateItem.interface';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetTypeGroupTO } from 'src/app/models/betType/transportObjects/betTypeGroupTO.interface';
import { ISuperBetSettingsTO } from 'src/app/models/settings/transportObjects/superBetSettingsTO.interface';
import { ISuperBetSettings } from 'src/app/models/util/superBetSettings.interface';
import { IBusinessModelTO, IBusinessModelWithAdditionalSettingsTO } from 'src/app/models/settings/transportObjects/businessModelTO.interface';
import { IBusinessModel } from 'src/app/models/settings/businessModel.interface';
import { ICurrency } from 'src/app/models/settings/currency.interface';
import { IPlayedTicketTO, IPlayedTicketWithGroupsTO } from 'src/app/models/ticket/transportObjects/playedTicketTO.interface';
import { IPlayedTicket } from 'src/app/models/ticket/playedTicket';
import { UserService } from '../user.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { IPlayedTicketItemTO, IPlayedTicketItemTOsbv } from 'src/app/models/ticket/transportObjects/playedTicketItemTO.interface';
import { IPlayedTicketEvent } from 'src/app/models/ticket/playedTicketEvent';
import { IPlayedTicketOutcome } from 'src/app/models/ticket/playedTicketOutcome.interface';
import { UtilityService } from './utility.service';
import { IPlayedTicketState } from 'src/app/models/ticket/playedTicketState.interface';
import { IPlayedTicketStateTO } from 'src/app/models/ticket/transportObjects/playedTicketStateTO.interface';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { ITicketItem } from 'src/app/models/ticket/ticketItem.inerface';
import { IUpdateTicketRequestObjTO } from 'src/app/models/ticket/transportObjects/ubdateTicketRequestObjTO.interface';
import { IMultiwayRestrictionItemTO } from 'src/app/models/settings/transportObjects/multiwayRestrictionItemTO.interface';
import { IMultiwayRestrictionItem } from 'src/app/models/settings/multiwayRestrictionItem.interface';
import { IMultiwayRestrictionTO } from 'src/app/models/settings/transportObjects/multiwayRestrictionTO.interface';
import { IMultiwayRestriction } from 'src/app/models/settings/multiwayRestriction.interface';
import { IBonusSettings } from 'src/app/models/settings/bonusSettings.interface';
import { IBonusSettingsTO } from 'src/app/models/settings/transportObjects/bonusSettingsTO.interface';
import { IFreeBetSettingTO } from 'src/app/models/settings/transportObjects/freeBetSettingTO.interface';
import { IFreeBetSetting } from 'src/app/models/settings/freeBetSetting.interface';
import { IFreeBetSettingHierarchyTO } from 'src/app/models/settings/transportObjects/freeBetSettingHierarchyTO.interface';
import { IFreeBetSettingHierarchy } from 'src/app/models/settings/freeBetSettingHierarchy.interface';
import { IBonusSettingHierarchyTO } from 'src/app/models/settings/transportObjects/bonusSettingsHierarchyTO.interface';
import { IBonusSettingHierarchy } from 'src/app/models/settings/bonusSettingsHierarchy.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ITicketGroup } from 'src/app/models/ticket/ticketGroup.interface';
import { ITicket } from 'src/app/models/ticket/ticket.interface';
import { ITicketItemForTicket } from 'src/app/models/ticket/itemForTicketObject.interface';
import { IBetValue } from 'src/app/models/ticket/betValue.interface';
import { IJTBetPointTO } from 'src/app/models/jacktime/transportObjects/betPointTO.interface.ts';
import { IJTBetPoint } from 'src/app/models/jacktime/betPoint.interface.ts';
import { IBetHistoryJTResponseTO } from 'src/app/models/jacktime/transportObjects/betHistoryResponseTO.interface';
import { IBetHistoryJTResponse } from 'src/app/models/jacktime/betHistoryResponse.interface';
import { IRemoteOperationResultTO } from 'src/app/models/ticket-validation/transportObjects/remoteOperationResultTO.interface.';
import { IRemoteOperationResult } from 'src/app/models/ticket-validation/remoteOperationResult.interface.';
import { ISellBetResponse } from 'src/app/models/ticket-validation/sellBetResponse.interface';
import { ISellBetResponseTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTO.interface';
import { ITicketValidationResultTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationResultTO.interface';
import { ITicketValidationResult } from 'src/app/models/ticket-validation/ticketValidationResult.interface';
import { ITicketTO } from 'src/app/models/ticket/transportObjects/ticketTO.interface';
import { ITicketGroupTO } from 'src/app/models/ticket/transportObjects/ticketGroupTO.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ITicketItemTO } from 'src/app/models/ticket/transportObjects/ticketItemTO.interface';
import { IBetOutcomeMinTO } from 'src/app/models/cacheChanges/transportObject/betOutcomeTO.min.interface';
import { IBetMinTO } from 'src/app/models/cacheChanges/transportObject/betTO.min.interface';
import { IEventMinTO } from 'src/app/models/cacheChanges/transportObject/eventTO.min.interface';
import { IEventLiveResultInfoMinTO } from 'src/app/models/cacheChanges/transportObject/eventLiveResultInfoTO.min.interface';
import { ICacheMinTO } from 'src/app/models/cacheChanges/transportObject/cacheTO.min.interface';
import { ICacheChanges } from 'src/app/models/cacheChanges/cacheChanges.interface';
import { ITOEventsTableConfiguration } from 'src/app/models/betType/temp/TOEventsTableConfiguration.interface';
import { TOCompetitionEventsColumnType } from 'src/app/models/betType/temp/TOEventColumnDefinition.interface';
import { ITicketValidationRequestTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ITicketConfirmationRequestTO } from 'src/app/models/ticket/transportObjects/ticketConfirmationRequest.interface';
import { ISportWithCompetitions } from 'src/app/models/sportHierarchy/sportWithCompetitions.interface';
import { IBetV2TO } from 'src/app/models/bet/transportObjects/betV2TO.interface';
import { IBetOutcomeV2TO } from 'src/app/models/bet/transportObjects/betOutcomeV2TO.interface';
import { IEventV2TO } from 'src/app/models/event/transportObjects/eventV2TO.interface';
import { ISpecialOfferButtonTO } from 'src/app/models/sportHierarchy/transportObjects/specialOfferButtonTO.interface';
import { ITicketDialogModel } from 'src/app/models/ticket-validation/ticketDialogModel.interface';
import { IBetOutcomeWithPlayableStatusTO } from 'src/app/models/ticket/transportObjects/outcomeWithPlayableStatusTO.interface';
import { IBetOutcomeWithPlayableStatus } from 'src/app/models/ticket/outcomeWithPlayableStatus.interface';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { ITicketData } from 'src/app/models/ticket/ticketData.interface';
import { ISystemOption } from 'src/app/models/ticket/system-option.interface';
import { EventKeyTO } from 'src/app/models/messaging/eventKeyTO.interface';
import { FcmSubscriptionRequestTO } from 'src/app/models/messaging/fcmSubscriptionRequestTO.interface';
import { IDailyOddSheets } from 'src/app/models/oddSheets/dailyOddSheets.interface';
import { IOddSheet } from 'src/app/models/oddSheets/oddSheet.interface';
import { IOddSheets } from 'src/app/models/oddSheets/oddSheets.interface';
import { IDailyOddSheetsTO } from 'src/app/models/oddSheets/transportObjects/dailyOddSheetsTO.interface';
import { IOddSheetsTO } from 'src/app/models/oddSheets/transportObjects/oddSheetsTO.interface';
import { IOddSheetTO } from 'src/app/models/oddSheets/transportObjects/oddSheetTO.interface';
import { StorageService } from './storage.service';
import { IWebScoreTO } from 'src/app/models/results/transportObjects/webScoreTO.interface';
import { IGroupResult } from 'src/app/models/results/groupResult.interface';
import { IScoreGroup } from 'src/app/models/results/scoreGroup.interface';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { IWebEventResultTO } from 'src/app/models/results/transportObjects/webEventResultTO.interface';

import { IEvenResultsAndScoreGroups } from 'src/app/models/results/evenResultsAndScoreGroups.interface';
import { IWebEventResultsResponseTO } from 'src/app/models/results/transportObjects/webEventResultsResponseTO.interface';

import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { ITicketItemWebScoreTO } from 'src/app/models/results/transportObjects/ticketItemWebScoreTO.interface';
import { ITicketResultGroup } from 'src/app/models/ticket/ticketResultGroup.interface';
import { ISportForLiveTreeTO } from 'src/app/models/sportHierarchy/transportObjects/sportForLiveTreeTO.interface';
import { IWebRegionTO } from 'src/app/models/sportHierarchy/transportObjects/webRegionTO.interface';
import { IWebCompetitionTO } from 'src/app/models/sportHierarchy/transportObjects/webCompetitionTO.interface';
import { IOutcomeCodeValue } from 'src/app/models/betType/outcomeCodeValue.interface';
import { IOutcomeCodeValueTO } from 'src/app/models/betType/transportObjects/outcomeCodeValueTO.interface';
import { ITicketItemGroupPrintViewModel } from 'src/app/ticket-manager/models/print/ITicketItemGroupPrint.interface';
import { ITicketPrintViewModel } from 'src/app/ticket-manager/models/print/ticketPrintViewModel.interface';
import { ISellBetResponseTmTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTmTO.interface';
import { ISellBetResponseTm } from 'src/app/models/ticket-validation/sellBetResponseTm.interface';
import { ICurrencyWithSecondaryCurrencyTO } from 'src/app/models/settings/transportObjects/currencyWithSecondaryCurrencyTO.interface';
import { IBetTypeOutcomeGroupingTemplateItemTO } from 'src/app/models/betType/transportObjects/betTypeOutcomeGroupingTemplateItemTO.interface';
import { IBetTypeOutcomeGroupingTemplateItem } from 'src/app/models/betType/betTypeOutcomeGroupingTemplateItem.interface';
import { IExpressTicketTO } from 'src/app/models/ticket/transportObjects/expressTicketTO.interface';
import { IExpressTicket } from 'src/app/models/ticket/expresTicket.interface';
import { IExpressTicketItemGroupTO } from 'src/app/models/ticket/transportObjects/expressTicketItemGroupTO.interface';
import { IExpressTicketItemTO } from 'src/app/models/ticket/transportObjects/expressTicketItemTO.interface';
import { environment } from 'src/environments/environment';


@Injectable()
export class ModelMapperService {
  private languageCulture: string;
  constructor(
    private userService: UserService,
    private utilityService: UtilityService,
    private storageService: StorageService) {

    this.languageCulture = LocaleHelper.cultureName[storageService.language];

  }

  public createSportWithCompetitions(sport: ISport): ISportWithCompetitions {
    return {
      eventsCount: sport.eventsCount,
      id: sport.id,
      name: sport.name,
      competitions: [],
      orderNo: sport.orderNo
    };
  }

  public mapSport(iSportTO: ISportTO, orderNo: number, specialOfferType: SpecialOfferType = null): ISport {
    // const regions: IRegion[] = iSportTO.regions.map((regTO) => this.mapRegion(regTO, iSportTO.name));
    // let competitions: ICompetition[] = [];

    // for (const region of regions) {
    //   competitions.push(...region.competitions);
    // }

    // competitions = competitions.sort((a, b) => {
    //   if (a.regionName > b.regionName) {
    //     return 1;
    //   }
    //   if (a.regionName < b.regionName) {
    //     return -1;
    //   }
    //   return 0;
    // });

    // competitions = competitions.sort((a, b) => {
    //   if (a.name > b.name) {
    //     return 1;
    //   }
    //   if (a.name < b.name) {
    //     return -1;
    //   }
    //   return 0;
    // });

    return {
      eventsCount: iSportTO.eventsCount,
      id: iSportTO.id,
      isSelected: false,
      name: iSportTO.name,
      regions: [],
      // competitions,
      // selections: [],
      showRegions: false,
      orderNo,
      specialOfferType,
      isFavoriteExpanded: false
    };
  }

  public mapSportForLiveTree(iSportTO: ISportForLiveTreeTO, orderNo: number, specialOfferType: SpecialOfferType = null): ISport {
    return {
      eventsCount: iSportTO.eventsCount,
      id: iSportTO.id,
      isSelected: false,
      name: iSportTO.name,
      regions: [],
      // competitions,
      // selections: [],
      showRegions: false,
      orderNo,
      specialOfferType,
      isFavoriteExpanded: false
    };
  }

  public mapSportFromSpecialOfferButtonTO(specialOfferButtonTO: ISpecialOfferButtonTO, id: number): ISport {
    const sport: ISport = {
      eventsCount: specialOfferButtonTO.eventsCount,
      id,
      isSelected: false,
      name: null,
      regions: [],
      // competitions,
      // selections: [],
      showRegions: false,
      orderNo: this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights) === id ? 0 : id,
      specialOfferType: specialOfferButtonTO.id
    };

    let i = 0;
    for (const sportTO of specialOfferButtonTO.sports) {
      i++;
      sport.regions.push(this.specialSportTOToRegion(sportTO, i));
    }

    if (specialOfferButtonTO.id === SpecialOfferType.SuperBet) {
      sport.name = DynamicTranslations.otherTranslations_BreadCrumbsPageTitle_SuperBet;
    } else if (specialOfferButtonTO.id === SpecialOfferType.EventOfDay) {
      sport.name = DynamicTranslations.otherTranslations_BreadCrumbsPageTitle_EventOfDay;
    } else if (specialOfferButtonTO.id === SpecialOfferType.Outrights) {
      sport.name = DynamicTranslations.otherTranslations_BreadCrumbsPageTitle_Outrights;
    }


    return sport;
  }

  public mapRegion(iRegionTO: IRegionTO, sportName: string, orderNo: number): IRegion {
    return {
      competitions: [], // iRegionTO.competitions.map((iCompetitionTO) => this.mapCompetition(iCompetitionTO, sportName, iRegionTO.name)),
      eventsCount: iRegionTO.eventsCount,
      id: iRegionTO.id,
      isSelected: false,
      name: iRegionTO.name,
      shortName: iRegionTO.shortName,
      showCompetitions: false,
      sportId: iRegionTO.sportId,
      orderNo
    };
  }

  public mapWebRegion(iRegionTO: IWebRegionTO, sportName: string, orderNo: number): IRegion {
    return {
      competitions: [], // iRegionTO.competitions.map((iCompetitionTO) => this.mapCompetition(iCompetitionTO, sportName, iRegionTO.name)),
      eventsCount: iRegionTO.eventsCount,
      id: iRegionTO.id,
      isSelected: false,
      name: iRegionTO.regionName,
      shortName: iRegionTO.regionName?.substring(0, 3),
      showCompetitions: false,
      sportId: iRegionTO.sportId,
      orderNo
    };
  }

  public mapCompetition(iCompetitionTO: ICompetitionTO, sportName: string, regionName: string, orderNo: number): ICompetition {
    return {
      events: [],
      eventsCount: iCompetitionTO.eventsCount,
      id: iCompetitionTO.id,
      isSelected: false,
      name: iCompetitionTO.name,
      regionId: iCompetitionTO.regionId,
      regionName,
      shortName: iCompetitionTO.shortName,
      sportId: iCompetitionTO.sportId,
      sportName,
      isExpanded: false,
      isInFavorites: false,
      isShown: true,
      orderNo
    };
  }

  public mapWebCompetition(iCompetitionTO: IWebCompetitionTO, sportName: string, regionName: string, orderNo: number, sportId: number): ICompetition {
    return {
      events: [],
      eventsCount: iCompetitionTO.eventsCount,
      id: iCompetitionTO.competitionId,
      isSelected: false,
      name: iCompetitionTO.competitionName,
      regionId: iCompetitionTO.regionId,
      regionName,
      shortName: '',
      sportId,
      sportName,
      isExpanded: false,
      isInFavorites: false,
      isShown: true,
      orderNo,
      liveFavouriteOrderNumber: iCompetitionTO.liveFavouriteOrderNumber
    };
  }

  public mapBetTypeSelection(iBetTypeSelectionTO: IBetTypeSelectionTO): IBetTypeSelection {
    return {
      id: iBetTypeSelectionTO.id,
      betProductPageId: iBetTypeSelectionTO.betProductPageId,
      sportId: iBetTypeSelectionTO.sportId,
      betTypeId: iBetTypeSelectionTO.betTypeId,
      hasSBV: iBetTypeSelectionTO.hasSBV,
      betTypeName: iBetTypeSelectionTO.betTypeName,
      sbvSelectionType: iBetTypeSelectionTO.sBVSelectionType,
      sbvExactValue: iBetTypeSelectionTO.sBVExactValue,
      isSelected: false,
      orderNumber: iBetTypeSelectionTO.orderNumber,
      betTypeOutcomes: [],
      sbvDispalyType: SBVDisplayType.SBVAlone
    };
  }

  public mapBetTypeOutcome(iBetTypeOutcomeTO: IBetTypeOutcomeTO): IBetTypeOutcome {
    return {
      id: iBetTypeOutcomeTO.id,
      name: iBetTypeOutcomeTO.name,
      shortName: iBetTypeOutcomeTO.shortName,
      orderNumber: iBetTypeOutcomeTO.orderNumber,
      betTypeId: iBetTypeOutcomeTO.betTypeId,
      terminalShowType: iBetTypeOutcomeTO.terminalShowType,
      desktopShowType: iBetTypeOutcomeTO.desktopShowType,
      mobileShowType: iBetTypeOutcomeTO.mobileShowType,
      customName: iBetTypeOutcomeTO.customName,
      descriptions: iBetTypeOutcomeTO.descriptions,
      isSelected: false,
      code: iBetTypeOutcomeTO.code,
      isFreeText: iBetTypeOutcomeTO.isFreeText
    };
  }

  public mapBetType(iBetTypeTO: IBetTypeTO): IBetType {
    return {
      id: iBetTypeTO.id,
      name: iBetTypeTO.name,
      shortName: iBetTypeTO.shortName,
      orderNumber: iBetTypeTO.orderNumber,
      showType: iBetTypeTO.showType,
      sbvDisplayType: iBetTypeTO.sBVDisplayType ? iBetTypeTO.sBVDisplayType as SBVDisplayType : SBVDisplayType.NoSbv,
      betTypeOutcomes: iBetTypeTO.betTypeOutcomes.map((ibetTypeoutcometo) => this.mapBetTypeOutcome(ibetTypeoutcometo)),
      isLive: iBetTypeTO.isLive,
      canUseParticipantNameAsOutcomesNames: iBetTypeTO.canUseParticipantNameAsOutcomesNames,
      isSelected: false
    };
  }

  public mapBetTypeShowType(iBetTypeShowTypeTO: IBetTypeShowTypeTO): IBetTypeShowType {
    const btos: { [betTypeOutcomeId: number]: IBetTypeOutcome } = {};
    const lowerBtName: string = iBetTypeShowTypeTO.betTypeName.toLowerCase();
    const betTypeShowType = {
      betTypeId: iBetTypeShowTypeTO.betTypeId,
      betTypeName: iBetTypeShowTypeTO.betTypeName,
      // eslint-disable-next-line max-len
      betTypeOutcomesList: Object.entries(iBetTypeShowTypeTO.betTypeOutcomes).map(([key, value]) => btos[key] = this.mapBetTypeOutcome(value)),
      betTypeOutcomes: {},
      id: iBetTypeShowTypeTO.id,
      orderNumber: iBetTypeShowTypeTO.orderNumber,
      sbvDisplayType: iBetTypeShowTypeTO.sBVDisplayType !== null ? iBetTypeShowTypeTO.sBVDisplayType as SBVDisplayType : SBVDisplayType.NoSbv,
      showType: iBetTypeShowTypeTO.showType,
      topMinutesEnabled: iBetTypeShowTypeTO.topMinutesEnabled,
      betOrderingType: iBetTypeShowTypeTO.betOrderingType,
      betTypeDescription: iBetTypeShowTypeTO.description,
      numberOfBetsInRow: iBetTypeShowTypeTO.numberOfBetsInRow ? iBetTypeShowTypeTO.numberOfBetsInRow : 1,
      isHandicap: lowerBtName.includes('handicap') || lowerBtName.includes('hendikep')
    };
    betTypeShowType.betTypeOutcomes = btos;
    this.utilityService.sortByOrderNumber(betTypeShowType.betTypeOutcomesList);
    return betTypeShowType;
  }

  public mapBetTypeShowTypes(iBetTypesShowTypes: IBetTypesShowTypesTO): { [betTypeId: number]: IBetTypeShowType } {
    const btst: { [betTypeId: number]: IBetTypeShowType } = {};
    const betTypeShowTypeKeys = Object.keys(iBetTypesShowTypes);
    for (const key of betTypeShowTypeKeys) {
      btst[+key] = this.mapBetTypeShowType(iBetTypesShowTypes[key]);
    }
    return btst;
  }

  public mapBetOutcome(iBetOutcomeTO: IBetOutcomeTO, isLive: boolean, isSelected: boolean = false): IBetOutcome {
    return {
      id: iBetOutcomeTO.id,
      sportId: iBetOutcomeTO.sportId,
      regionId: iBetOutcomeTO.regionId,
      competitionId: iBetOutcomeTO.competitionId,
      betId: iBetOutcomeTO.betId,
      betTypeId: iBetOutcomeTO.betTypeId,
      betTypeOutcomeId: iBetOutcomeTO.betTypeOutcomeId,
      cashBackEnabled: iBetOutcomeTO.cashBackEnabled,
      eventId: iBetOutcomeTO.eventId,
      isInOffer: iBetOutcomeTO.isInOffer,
      isLive,
      isPlayable: iBetOutcomeTO.isPlayable,
      name: iBetOutcomeTO.name,
      odd: iBetOutcomeTO.odd,
      orderNo: iBetOutcomeTO.orderNo,
      resultStatus: iBetOutcomeTO.resultStatus,
      sbv: iBetOutcomeTO.sBV,
      description: iBetOutcomeTO.description,
      isSelected,
      // higherLowerOdd: BetOutcomeOddDifference.None,
      oldOdd: null,
    } as IBetOutcome;
  }

  public mapBetOutcomeFromV2(iBetOutcomeV2TO: IBetOutcomeV2TO, isLive: boolean, isSelected: boolean): IBetOutcome {
    return {
      id: iBetOutcomeV2TO.id,
      sportId: iBetOutcomeV2TO.sportId,
      regionId: iBetOutcomeV2TO.regionId,
      competitionId: iBetOutcomeV2TO.competitionId,
      betId: iBetOutcomeV2TO.betId,
      betTypeId: iBetOutcomeV2TO.betTypeId,
      betTypeOutcomeId: iBetOutcomeV2TO.betTypeOutcomeId,
      cashBackEnabled: iBetOutcomeV2TO.cashBackEnabled,
      eventId: iBetOutcomeV2TO.eventId,
      isInOffer: iBetOutcomeV2TO.isInOffer,
      isLive,
      isPlayable: iBetOutcomeV2TO.isPlayable,
      name: iBetOutcomeV2TO.name,
      odd: iBetOutcomeV2TO.odd,
      orderNo: iBetOutcomeV2TO.orderNo,
      resultStatus: iBetOutcomeV2TO.resultStatus,
      sbv: iBetOutcomeV2TO.sBV,
      description: null,
      isSelected,
      // higherLowerOdd: BetOutcomeOddDifference.None,
      oldOdd: null,
    } as IBetOutcome;
  }

  // remove map outcome and send it as param
  public mapBet(iBetTO: IBetTO, orderNo: number, isLive: boolean, mapOutcomes: boolean, betTypeShowType: IBetTypeShowType): IBet {
    let betOutcomesDictionary: { [betTypeOutcomeId: number]: IBetOutcome[] } = {};
    let betOutcomes: IBetOutcome[] = [];
    let hasPlayableOutcomes = false;
    if (mapOutcomes) {
      betOutcomesDictionary = {};
      betOutcomes = iBetTO.betOutcomes.map((iOutocmeTO) => {
        const bo = this.mapBetOutcome(iOutocmeTO, isLive, this.storageService.isOutcomeInTicket(iOutocmeTO.eventId, iOutocmeTO.id));
        if (!betOutcomesDictionary[bo.betTypeOutcomeId]) {
          betOutcomesDictionary[bo.betTypeOutcomeId] = [];
        }
        if (bo.isInOffer && bo.isPlayable) {
          hasPlayableOutcomes = true;
        }
        betOutcomesDictionary[bo.betTypeOutcomeId].push(bo);
        return bo;
      });
    }
    return {
      id: iBetTO.id,
      betTypeId: iBetTO.betTypeId,
      sbv: iBetTO.sBV,
      orderNo,
      sportId: iBetTO.sportId,
      regionId: iBetTO.regionId,
      competitionId: iBetTO.competitionId,
      eventId: iBetTO.eventId,
      betOutcomes,
      betOutcomesDic: betOutcomesDictionary,
      isMostBalanced: iBetTO.isMostBalanced,
      isLive,
      isInOffer: iBetTO.isInOffer,
      isPlayable: iBetTO.isPlayable,
      cashBackEnabled: iBetTO.cashBackEnabled,
      outrightName: iBetTO.betTypeName,
      hasPlayableOutcomes,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe
    };
  }

  public mapBetFromV2(iBetV2TO: IBetV2TO, orderNo: number, isLive: boolean, betTypeShowType: IBetTypeShowType): IBet {
    return {
      id: iBetV2TO.id,
      betTypeId: iBetV2TO.betTypeId,
      sbv: iBetV2TO.sBV,
      orderNo,
      sportId: iBetV2TO.sportId,
      regionId: iBetV2TO.regionId,
      competitionId: iBetV2TO.competitionId,
      eventId: iBetV2TO.eventId,
      betOutcomes: [],
      betOutcomesDic: {},
      isMostBalanced: iBetV2TO.isMostBalanced,
      isLive,
      isInOffer: iBetV2TO.isInOffer,
      isPlayable: iBetV2TO.isPlayable,
      cashBackEnabled: iBetV2TO.cashBackEnabled,
      outrightName: iBetV2TO.outrightName,
      hasPlayableOutcomes: false,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe
    };
  }

  public mapEventLiveResult(iResultTO: IEventLiveResultInfoTO): IEventLiveResultInfo {
    let betStatus = '';
    let eventId = 0;
    let extMatchTime = '';
    let gameScore = '';
    let matchTime = '';
    let score = '';
    let server = 0;
    let setScore = '';
    let status = '';
    let tiebreak = false;
    let sportId = 0;
    let regionId = 0;
    let competitionId = 0;
    let isTopMinute = false;
    let homeSetScore = [''];
    let awaySetScore = [''];
    let homeScore = '';
    let awayScore = '';
    let homeGameScore = '';
    let awayGameScore = '';
    let homePeriodScore = '';
    let awayPeriodScore = '';
    let homeRedCards = 0;
    let awayRedCards = 0;
    let stoppageTimeAnnounced = '';

    if (iResultTO) {
      isTopMinute = iResultTO.isTopMinute;
      betStatus = iResultTO.betStatus;
      sportId = iResultTO.sportId;
      regionId = iResultTO.regionId;
      competitionId = iResultTO.competitionId;
      eventId = iResultTO.id;
      extMatchTime = iResultTO.extMatchTime;
      gameScore = iResultTO.gameScore;
      stoppageTimeAnnounced = iResultTO.stoppageTimeAnnounced ? iResultTO.stoppageTimeAnnounced.split(':')[0] : iResultTO.stoppageTimeAnnounced;
      // stoppageTimeAnnounced = '3:00'.split(':')[0];
      // console.log('stoppageTimeAnnounced', stoppageTimeAnnounced);

      if (iResultTO.matchTime) {
        matchTime = iResultTO.matchTime + '\'';
      } else {
        matchTime = iResultTO.matchTime;
      }
      score = iResultTO.score;
      server = iResultTO.server;
      setScore = iResultTO.setScore;
      status = iResultTO.status;
      tiebreak = iResultTO.tiebreak;

      if (iResultTO.score) {
        homeSetScore = [];
        awaySetScore = [];
        const tmpScore: string[] = iResultTO.score.split(':');
        homeScore = tmpScore[0];
        awayScore = tmpScore[1];
      }

      if (iResultTO.setScore) {
        const tmpSetScore: string[] = iResultTO.setScore.split(' - ');
        if (tmpSetScore.length > 0) {
          tmpSetScore.forEach(singleSet => {
            const singleSetScore = singleSet.split(':');
            homeSetScore.push(singleSetScore[0]);
            awaySetScore.push(singleSetScore[1]);
          });
        }

        switch (iResultTO.sportId) {
          case 1:
          case 4:
          case 6:
          case 11:
          case 24:
            homePeriodScore = homeSetScore[0] ? homeSetScore[0] : '';
            awayPeriodScore = awaySetScore[0] ? awaySetScore[0] : '';
            break;

          case 3:
          case 17:
          case 20:
          case 25:
          case 27:
            homePeriodScore = homeSetScore[homeSetScore.length - 1];
            awayPeriodScore = awaySetScore[awaySetScore.length - 1];
            break;

          case 2:
          case 15:
          case 22:
            homePeriodScore = homeSetScore[1] ? (+homeSetScore[0] + (+homeSetScore[1])).toString() : homeSetScore[0];
            awayPeriodScore = awaySetScore[1] ? (+awaySetScore[0] + (+awaySetScore[1])).toString() : awaySetScore[0];
            break;

          default:
            homePeriodScore = homeSetScore[0] ? homeSetScore[0] : '';
            awayPeriodScore = awaySetScore[0] ? awaySetScore[0] : '';
            break;
        }
      }

      if (iResultTO.gameScore) {
        const tmpGameScore: string[] = iResultTO.gameScore.split(':');

        if (tmpGameScore[0] === '50') {
          homeGameScore = 'Adv';
        } else {
          homeGameScore = tmpGameScore[0];
        }

        if (tmpGameScore[1] === '50') {
          awayGameScore = 'Adv';
        } else {
          awayGameScore = tmpGameScore[1];
        }
      }

      if (iResultTO.redCards) {
        const tmpRedCards: string[] = iResultTO.redCards.split(':');
        homeRedCards = +tmpRedCards[0];
        awayRedCards = +tmpRedCards[1];
      }
    }

    return {
      betStatus,
      eventId,
      extMatchTime,
      gameScore,
      matchTime,
      score,
      server,
      setScore,
      status,
      tiebreak,
      sportId,
      regionId,
      competitionId,
      isTopMinute,
      homeSetScore,
      awaySetScore,
      homeScore,
      awayScore,
      homeGameScore,
      awayGameScore,
      homePeriodScore,
      awayPeriodScore,
      homeRedCards,
      awayRedCards,
      stoppageTimeAnnounced
    };
  }


  public mapEventFromV2(
    iEventV2TO: IEventV2TO,
    languageCulture: string,
    dateFormat: Intl.DateTimeFormatOptions,
    isNotificationEnabled: boolean,
    sportName?: string,
    regionName?: string,
    competitionName?: string,
    orderNo?: number
    ): EventVM {
    const ev = new EventVM();
    ev.id = iEventV2TO.id;
    ev.code = iEventV2TO.code;
    ev.status = iEventV2TO.status;
    ev.dateTime = new Date(iEventV2TO.dateTime.replace('Z', '') + 'Z');
    ev.competitionId = iEventV2TO.competitionId;
    ev.regionId = iEventV2TO.regionId;
    ev.sportId = iEventV2TO.sportId;
    ev.competitionName = competitionName ? competitionName : iEventV2TO.competitionName;
    ev.isPlayable = iEventV2TO.isPlayable;
    ev.isInOffer = iEventV2TO.isInOffer;
    ev.eventName = iEventV2TO.name;
    ev.isNotificationEnabled = isNotificationEnabled;
    ev.isLive = iEventV2TO.isLive;

    // for specials we dont have away team
    if (!environment.specialSportIds.includes(ev.sportId)) {
      const teams: string[] = iEventV2TO.name.split(' - ');
      ev.homeTeam = teams[0] ? teams[0] : '';
      ev.awayTeam = teams[1] ? teams[1] : '';

      if (iEventV2TO.shortName) {
        const teamsShort: string[] = iEventV2TO.shortName.split(' - ');
        ev.homeTeamShort = teamsShort[0] ? teamsShort[0] : '';
        ev.awayTeamShort = teamsShort[1] ? teamsShort[1] : '';
      }
    } else {
      ev.homeTeam = iEventV2TO.name;
      ev.homeTeamShort = iEventV2TO.shortName;
    }

    ev.betsCount = iEventV2TO.betsCount;
    ev.cashBackEnabled = iEventV2TO.cashBackEnabled;
    let externalEventIdSplited: string[] = [];

    if (iEventV2TO.betRadarEventId) {
      ev.betRadarEventId = iEventV2TO.betRadarEventId;
    } else if (iEventV2TO.externalEventId) {
      if (isNaN(+iEventV2TO.externalEventId)) {
        externalEventIdSplited = iEventV2TO.externalEventId.split('sr:match:');
        ev.betRadarEventId = externalEventIdSplited.length === 2 ? +externalEventIdSplited[1] : null;
      } else {
        ev.betRadarEventId = +iEventV2TO.externalEventId;
      }
    }

    ev.result = null;
    ev.playableBetsCount = iEventV2TO.playableBetsCount;
    ev.selectedBetTypeId = null;
    ev.regionName = regionName ? regionName : iEventV2TO.regionName;
    ev.sportName = sportName ? sportName : iEventV2TO.sportName;
    ev.orderNo = orderNo ? orderNo : -1;
    ev.mappingType = iEventV2TO.mappingTypeId;
    ev.siblingdEventId = iEventV2TO.siblingStandardEventId;
    ev.eventDate = ev.dateTime.toLocaleDateString(languageCulture, dateFormat);
    ev.eventTime = ev.dateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' });
    ev.eventType = iEventV2TO.eventTypeId;
    ev.specialOfferType = this.utilityService.getSpecialOfferType(ev.mappingType, ev.eventType);
    // console.log('languageCulture: '+ languageCulture +  ' eventDate:'+ ev.eventDate);
    return ev;
  }




  public mapEvent(
    iEventTO: IEventTO,
    sportName: string,
    regionName: string,
    competitionName: string,
    languageCulture: string,
    dateFormat: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' },
    mapBetsAndOutcomes: boolean,
    isNotificationEnabled: boolean,
    betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): EventVM {
    const ev = new EventVM();
    ev.id = iEventTO.id;
    ev.code = iEventTO.code.trim();
    ev.status = iEventTO.status;
    // later remove z
    ev.dateTime = new Date(iEventTO.dateTime.replace('Z', '') + 'Z');
    ev.competitionId = iEventTO.competitionId;
    ev.regionId = iEventTO.regionId;
    ev.sportId = iEventTO.sportId;
    ev.competitionName = competitionName ? competitionName : iEventTO.competitionName ? iEventTO.competitionName : null;
    ev.isPlayable = iEventTO.isPlayable;
    ev.isInOffer = iEventTO.isInOffer;
    ev.eventName = iEventTO.eventName;
    ev.isLive = iEventTO.isLive;
    ev.isNotificationEnabled = isNotificationEnabled;
    let i = 1;
    if (mapBetsAndOutcomes) {
      iEventTO.bets.forEach((betTO) => {
        if (!ev.betGroups[betTO.betTypeId]) {

          ev.betGroups[betTO.betTypeId] = this.utilityService.createBetsGroup();
        }
        ev.betGroups[betTO.betTypeId].bets[betTO.id] = this.mapBet(betTO, i, iEventTO.isLive, mapBetsAndOutcomes, betTypeShowTypes[betTO.betTypeId]);
        if (betTO.isPlayable || !ev.betGroups[betTO.betTypeId].betToShow) {
          // for Later  setup betToShow when exact or most balanced when event model is returned
          ev.betGroups[betTO.betTypeId].betToShow = ev.betGroups[betTO.betTypeId].bets[betTO.id];
        }
        i++;
      });
    }

    const teamsShort: string[] = iEventTO.eventShortName.split(' - ');
    ev.homeTeamShort = teamsShort[0] ? teamsShort[0] : '';
    ev.awayTeamShort = teamsShort[1] ? teamsShort[1] : '';

    ev.homeTeam = iEventTO.homeTeam;
    ev.awayTeam = iEventTO.awayTeam;
    ev.betsCount = iEventTO.betsCount;
    ev.cashBackEnabled = iEventTO.cashBackEnabled;
    ev.betRadarEventId = iEventTO.betRadarEventId;
    // const ids = [23611697, 23768927, 23369909];
    // const random = Math.floor(Math.random() * ids.length);
    // ev.betRadarEventId = ids[random];
    // ev.liveStreamId = ids[random];


    ev.result = null;
    ev.playableBetsCount = iEventTO.playableBetsCount;
    ev.selectedBetTypeId = null;
    ev.regionName = regionName ? regionName : iEventTO.regionName ? iEventTO.regionName : null;
    ev.sportName = sportName;
    ev.orderNo = iEventTO.orderNo;
    ev.mappingType = iEventTO.mappingTypeId;
    ev.siblingdEventId = iEventTO.siblingStandardEventId;
    ev.eventDate = ev.dateTime.toLocaleDateString(languageCulture, dateFormat);
    ev.eventTime = ev.dateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' });
    ev.eventType = iEventTO.eventTypeId;
    ev.specialOfferType = this.utilityService.getSpecialOfferType(ev.mappingType, ev.eventType);
    return ev;
  }

  // mapBetTypeGroupingTemplateItem(item: IBetTypeGroupingTemplateItemTO, betTypeShowType: IBetTypeShowType = null): IBetTypeGroupingTemplateItem {
  //   return {
  //     isSelected: false,
  //     betTypeId: item.betTypeId,
  //     groupId: item.groupId,
  //     id: item.id,
  //     orderNumber: item.orderNumber,
  //     sbvExactValue: item.sBVExactValue,
  //     sbvSelectionType: item.sBVSelectionType,
  //     betTypeName: betTypeShowType ? betTypeShowType.betTypeName : null,
  //     betTypeOutcomes: betTypeShowType ? betTypeShowType.betTypeOutcomesList : null,
  //     sbvDisplayType: betTypeShowType ? betTypeShowType.sbvDisplayType : SBVDisplayType.NoSbv,
  //     betTypeDescription: betTypeShowType ? betTypeShowType.betTypeDescription : '',
  //   };
  // }

  mapBetTypeGroup(group: IBetTypeGroupTO, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): IBetTypeGroup {
    return {
      id: group.id,
      betTypeIds: group.betTypeIds,
      name: group.name,
      // betTypeGroupingTemplateItems: group.betTypeGroupingTemplateItems.map((item) => this.mapBetTypeGroupingTemplateItem(item, betTypeShowTypes ? betTypeShowTypes[item.betTypeId] : null)),
      betTypeGroupingTemplateItems: this.utilityService.sortByOrderNumber(group.betTypeGroupingTemplateItems.map((item) => this.mapBetTypeGroupingTemplateItem(item, betTypeShowTypes ? betTypeShowTypes[item.betTypeId] : null))),
      isSelected: false,
      isUserFavoriteButton: false,
      isOnline: true,
    };
  }

  mapSuperBetSettings(sbs: ISuperBetSettingsTO): ISuperBetSettings {
    return sbs;
  }

  mapBussinesModel(bm: IBusinessModelTO | IBusinessModelWithAdditionalSettingsTO): IBusinessModel {
    if ((bm as IBusinessModelWithAdditionalSettingsTO).businessModel) {
      return (bm as IBusinessModelWithAdditionalSettingsTO).businessModel;
    }
    return bm as IBusinessModelTO;
  }

  mapCurrency(currencyWithSecondary: ICurrencyWithSecondaryCurrencyTO): ICurrency {
    const currency: ICurrency = {
      id: null,
      name: null,
      code: null,
      symbol: null,
      predefinedDenominations: [],
      predefinedDenominationsSecondary: [],
      secondaryCurrrencyName: null,
      secondaryCurrrencyCode: null,
      secondaryCurrrencySymbol: null,
      exchangeRate: currencyWithSecondary.exchangeRate,
    };

    if (currencyWithSecondary.primaryCurrency) {
      currency.id = currencyWithSecondary.primaryCurrency.id;
      currency.name = currencyWithSecondary.primaryCurrency.name;
      currency.code = currencyWithSecondary.primaryCurrency.code;
      currency.symbol = currencyWithSecondary.primaryCurrency.symbol;
      currency.predefinedDenominations = currencyWithSecondary.primaryCurrency.predefinedDenominations ? currencyWithSecondary.primaryCurrency.predefinedDenominations : [];
    }

    if (currencyWithSecondary.secondaryCurrency) {
      currency.secondaryCurrrencyName = currencyWithSecondary.secondaryCurrency.name;
      currency.secondaryCurrrencyCode = currencyWithSecondary.secondaryCurrency.code;
      currency.secondaryCurrrencySymbol = currencyWithSecondary.secondaryCurrency.symbol;
      currency.predefinedDenominationsSecondary = currencyWithSecondary.secondaryCurrency.predefinedDenominations ? currencyWithSecondary.secondaryCurrency.predefinedDenominations : [];
    }

    return currency;
  }

  mapPlayedTicketFromTicketDialogModel(ticketDialogModel: ITicketDialogModel): IPlayedTicket {

    const playedTicket: IPlayedTicket = {} as IPlayedTicket;
    playedTicket.id = ticketDialogModel.confirmationOrPlayedTicket.id;
    playedTicket.system = ticketDialogModel.confirmationOrPlayedTicket.ticketTypeName;
    playedTicket.stake = ticketDialogModel.confirmationOrPlayedTicket.totalStake;
    playedTicket.stake = ticketDialogModel.confirmationOrPlayedTicket.requestedStake;
    playedTicket.possibleMaxWin = ticketDialogModel.confirmationOrPlayedTicket.possibleWin;
    playedTicket.possibleMinWin = ticketDialogModel.confirmationOrPlayedTicket.minWinings;
    playedTicket.totalOdd = ticketDialogModel.confirmationOrPlayedTicket.totalOdd;
    playedTicket.totalOdd = ticketDialogModel.confirmationOrPlayedTicket.requestedTotalOdd;
    playedTicket.bonus = ticketDialogModel.confirmationOrPlayedTicket.bonus;
    playedTicket.status = {
      name: TicketStatus[ticketDialogModel.confirmationOrPlayedTicket.statusId],
      code: ticketDialogModel.confirmationOrPlayedTicket.statusId
    };
    playedTicket.numberOfCombinations = ticketDialogModel.confirmationOrPlayedTicket.numOfCombinations;
    playedTicket.createdOn = ticketDialogModel.confirmationOrPlayedTicket.payoutDate;
    playedTicket.ticketNumber = ticketDialogModel.confirmationOrPlayedTicket.ticketId;
    playedTicket.system = ticketDialogModel.confirmationOrPlayedTicket.systemName;
    playedTicket.payin = ticketDialogModel.confirmationOrPlayedTicket.payin;
    playedTicket.taxBeforeStake = ticketDialogModel.confirmationOrPlayedTicket.taxBeforeStake;
    playedTicket.possiblePayout = ticketDialogModel.confirmationOrPlayedTicket.possiblePayout;
    playedTicket.possibleMinPayout = ticketDialogModel.confirmationOrPlayedTicket.possibleMinPayout;
    playedTicket.taxOnWinning = ticketDialogModel.confirmationOrPlayedTicket.taxOnWinning;
    playedTicket.taxOnMinWinning = ticketDialogModel.confirmationOrPlayedTicket.taxOnMinWinning;
    playedTicket.cashoutValue = ticketDialogModel.confirmationOrPlayedTicket.cashOutValue;

    // if (ticket.systemName.includes('Fix')) {
    //   ticket.systemName = ticket.systemName.substring(ticket.systemName.indexOf(',') + 1, ticket.systemName.length);
    // }
    // ticket.systemName = ticket.systemName.replace('MO ', '');
    // ticket.systemName = ticket.systemName.replace('System ', '');
    // ticket.systemName = ticket.systemName.substring(0, ticket.systemName.lastIndexOf('-')).replace(' ', '');


    playedTicket.createdOnDate = ticketDialogModel.createdOnDate;
    playedTicket.createdOnTime = ticketDialogModel.createdOnTime;
    playedTicket.system = ticketDialogModel.isFix ? 'Fix' : 'System';
    playedTicket.events = [];

    Object.entries(ticketDialogModel.ticketItemEventGroups).map(([k, v]) => v).forEach(ev => {
      const playedEvent: IPlayedTicketEvent = {
        id: ev.eventId,
        code: ev.eventCode,
        dateTime: ev.eventDateTime,
        name: ev.eventName,
        homeTeam: ev.eventHomeTeam,
        awayTeam: ev.eventAwayTeam,
        competitionId: ev.competitionId,
        competition: ev.competitionName,
        regionId: ev.regionId,
        region: ev.regionName,
        sportId: ev.sportId,
        sport: ev.sportName,
        result: ev.result,
        system: !ev.isInBankersGroup && !ticketDialogModel.isFix ? 'S' : 'F',
        outcomes: [],
        dateTimeShort: ev.eventDate,
        eventMappingType: ev.mappingType,
        liveScore: ev.liveScore,
        scores: ev.scores,
        isLive: ev.isLive,
        eventType: ev.eventType
      };
      playedTicket.events.push(playedEvent);

      Object.entries(ev.ticketItems).map(([k, v]) => v).forEach(ti => {
        playedEvent.outcomes.push({
          betTypeName: ti.betTypeName,
          betName: ti.betName ?? ti.betTypeName,
          sbv: ti.sbv,
          betTypeOutcomeName: ti.betOutcomeName,
          odd: ti.odd,
          status: {
            name: TicketStatus[ti.status],
            code: ti.status
          },
          betTypeId: ti.betTypeId,
          betTypeOutcomeId: ti.betTypeOutcomeId,
          betOutcomeId: ti.betOutcomeId,
          useSbvHandicapPipe: ti.useSbvHandicapPipe,
          betId: ti.betId,
          isLive: ti.isLive
        });
      });
    });
    return playedTicket;
  }

  mapTicketDialogModelFromPlayedTicket(playedTicket: IPlayedTicket): ITicketDialogModel {

    const ticketDialogModel: ITicketDialogModel = {} as ITicketDialogModel;
    const ticket: ITicket = {} as ITicket;
    ticket.id = playedTicket.id;
    ticket.ticketTypeName = playedTicket.system;
    ticket.totalStake = playedTicket.stake;
    ticket.requestedStake = playedTicket.stake;
    ticket.possibleWin = playedTicket.possibleMaxWin;
    ticket.minWinings = playedTicket.possibleMinWin;
    ticket.totalOdd = playedTicket.totalOdd;
    ticket.requestedTotalOdd = playedTicket.totalOdd;
    ticket.bonus = playedTicket.bonus;
    ticket.statusId = playedTicket.status.code;
    ticket.numOfCombinations = playedTicket.numberOfCombinations;
    ticket.payoutDate = playedTicket.createdOn;
    ticket.ticketId = playedTicket.ticketNumber;
    ticket.systemName = playedTicket.system;
    ticket.payin = playedTicket.payin;
    ticket.taxBeforeStake = playedTicket.taxBeforeStake;
    ticket.possiblePayout = playedTicket.possiblePayout;
    ticket.possibleMinPayout = playedTicket.possibleMinPayout;
    ticket.taxOnWinning = playedTicket.taxOnWinning;
    ticket.taxOnMinWinning = playedTicket.taxOnMinWinning;
    ticket.createdBy = playedTicket.createdBy;

    if (ticket.systemName.includes('Fix')) {
      ticket.systemName = ticket.systemName.substring(ticket.systemName.indexOf(',') + 1, ticket.systemName.length);
    }
    ticket.systemName = ticket.systemName.replace('MO ', '');
    ticket.systemName = ticket.systemName.replace('System ', '');
    ticket.systemName = ticket.systemName.substring(0, ticket.systemName.lastIndexOf('-')).replace(' ', '');

    ticketDialogModel.ticketType = TicketPlayType.PlayedTicket;
    ticketDialogModel.ticketItemEventGroups = {};
    ticketDialogModel.confirmationOrPlayedTicket = ticket;
    ticketDialogModel.createdOnDate = playedTicket.createdOnDate;
    ticketDialogModel.createdOnTime = playedTicket.createdOnTime;
    ticketDialogModel.isFix = playedTicket.system === 'Fix' ? true : false;

    ticketDialogModel.ticketData = {} as ITicketData;

    ticketDialogModel.ticketData.isTicketOnline = true;
    ticketDialogModel.ticketData.numberOfBets = ticket.numOfCombinations;
    ticketDialogModel.ticketData.totalStake = ticket.totalStake;
    ticketDialogModel.ticketData.wagerPerBet = ticket.totalStake / ticket.numOfCombinations;
    ticketDialogModel.ticketData.totalWinings = ticket.possibleWin;
    ticketDialogModel.ticketData.minWinings = ticket.minWinings;
    ticketDialogModel.ticketData.totalOdd = ticket.totalOdd;
    ticketDialogModel.ticketData.minOdd = ticket.minOdd;
    ticketDialogModel.ticketData.possibleWin = ticket.possibleWin;
    ticketDialogModel.ticketData.bonus = ticket.bonus;
    ticketDialogModel.ticketData.bonusPercent = ticket.bonusPercent;
    ticketDialogModel.ticketData.freeBetValue = ticket.freeBetValue;
    ticketDialogModel.ticketData.freeBetValueToShow = ticket.freeBetValue;
    ticketDialogModel.ticketData.payin = ticket.payin;
    ticketDialogModel.ticketData.taxBeforeStake = ticket.taxBeforeStake;
    ticketDialogModel.ticketData.possiblePayout = ticket.possiblePayout;
    ticketDialogModel.ticketData.possibleMinPayout = ticket.possibleMinPayout;
    ticketDialogModel.ticketData.taxOnWinings = ticket.taxOnWinning;
    ticketDialogModel.ticketData.taxOnMinWinning = ticket.taxOnMinWinning;
    ticketDialogModel.ticketData.possibleWinWithoutTax = ticket.possiblePayout;
    ticketDialogModel.systemTicketItemGroups = [];
    ticketDialogModel.bankerTicketItemGroups = [];
    ticketDialogModel.hasLiveItems = false;
    ticketDialogModel.systemName = ticket.systemName;

    const events: { [eventId: number]: ITicketItemGroup } = {};
    playedTicket.events.forEach(ev => {
      const ticketItemGroup: ITicketItemGroup = this.mapTicketItemGroupFromPlayedTicketEvent(ev, ticketDialogModel.isFix);
      events[ev.id] = ticketItemGroup;
      if (ticketItemGroup.isInBankersGroup || ticketDialogModel.isFix) {
        ticketDialogModel.bankerTicketItemGroups.push(ticketItemGroup);
        if (Object.keys(ticketItemGroup.ticketItems).length !== 1) {
          ticketDialogModel.isMultiplayBanker = true;
        }
      } else {
        ticketDialogModel.systemTicketItemGroups.push(ticketItemGroup);
        if (Object.keys(ticketItemGroup.ticketItems).length !== 1) {
          ticketDialogModel.isMultiplaySystem = true;
        }
      }
      if (ticketItemGroup.isLive) {
        ticketDialogModel.hasLiveItems = true;
      }
    });

    ticketDialogModel.ticketItemEventGroups = events;

    return ticketDialogModel;

  }

  mapTicketItemGroupFromPlayedTicketEvent(playedTicketEvent: IPlayedTicketEvent, isTicketFix: boolean): ITicketItemGroup {
    const outcomes: { [betOutcomeId: number]: ITicketItem } = {};

    playedTicketEvent.outcomes.forEach(ou => {
      outcomes[ou.betOutcomeId] = this.mapTicketItemFromPlayedTicketOutcome(ou);

    });

    // const homeSetScore = [];
    // const awaySetScore = [];
    // let homeScore = '';
    // let awayScore = '';
    // if (playedTicketEvent.result) {
    //   const tmpScore: string[] = playedTicketEvent.result.split('(');
    //   homeScore = tmpScore[0].split(':')[0];
    //   awayScore = tmpScore[0].split(':')[1];
    //   if (tmpScore[1]) {
    //     const tmpSetScoreReplace: string = tmpScore[1].replace('(', '').replace(')', '');
    //     const tmpSetScore: string[] = tmpSetScoreReplace.split(' - ');
    //     if (tmpSetScore.length > 0) {
    //       tmpSetScore.forEach(singleSet => {
    //         const singleSetScore = singleSet.split(':');
    //         homeSetScore.push(singleSetScore[0]);
    //         awaySetScore.push(singleSetScore[1]);
    //       });
    //     }
    //   }
    // }

    return {
      sportName: playedTicketEvent.sport,
      regionName: playedTicketEvent.region,
      competitionName: playedTicketEvent.competition,
      sportId: playedTicketEvent.sportId,
      regionId: playedTicketEvent.regionId,
      competitionId: playedTicketEvent.competitionId,
      eventId: playedTicketEvent.id,
      eventName: playedTicketEvent.homeTeam + ' - ' + playedTicketEvent.awayTeam,
      eventCode: playedTicketEvent.code,
      eventHomeTeam: playedTicketEvent.homeTeam,
      eventAwayTeam: playedTicketEvent.awayTeam,
      eventDateTime: playedTicketEvent.dateTime,
      eventDate: playedTicketEvent.dateTimeShort,
      // eventTime: playedTicketEvent.dateTime.toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' }),
      eventTime: '',
      mappingType: playedTicketEvent.eventMappingType,
      isInBankersGroup: isTicketFix || playedTicketEvent.system === 'S' ? false : true,
      ticketItems: outcomes,
      isEventPlayable: null,
      siblingEventId: null,
      isLive: playedTicketEvent.isLive,
      eventType: playedTicketEvent.eventType,
      result: playedTicketEvent.result,
      liveScore: playedTicketEvent.liveScore,
      eventDayShort: playedTicketEvent.dateTimeShort,
      betRadarEventId: null,
      scores: playedTicketEvent.scores
    };

  }

  mapTicketItemFromPlayedTicketOutcome(playedTicketOutcome: IPlayedTicketOutcome): ITicketItem {

    return {
      sbv: playedTicketOutcome.sbv,
      odd: playedTicketOutcome.odd,
      oldOdd: null,
      betId: playedTicketOutcome.betId,
      betOutcomeId: playedTicketOutcome.betOutcomeId,
      betTypeId: playedTicketOutcome.betTypeId,
      betTypeName: playedTicketOutcome.betTypeName,
      betName: playedTicketOutcome.betName ?? playedTicketOutcome.betTypeName,
      betTypeOutcomeId: playedTicketOutcome.betTypeOutcomeId,
      betOutcomeName: playedTicketOutcome.betTypeOutcomeName,
      isLive: playedTicketOutcome.isLive,
      isBetOutcomePlayable: null,
      isBetPlayable: null,
      // higherLowerOdd: null,
      status: playedTicketOutcome.status.code,
      useSbvHandicapPipe: playedTicketOutcome.useSbvHandicapPipe
    };
  }

  mapPlayedTicket(plTicketTO: IPlayedTicketWithGroupsTO, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }, ticketForUser: number): IPlayedTicket {
    let systemEventsCount = 0;
    let systemEventsInCombination: number[] = [];
    let fixEventsCount = 0;
    // later remove z
    const createdOn: Date = new Date(plTicketTO.createdOn.replace('Z', '') + 'Z');
    const events: IPlayedTicketEvent[] = [];
    // if (plTicketTO.system === 'Fix') {
    //   fixEventsCount = plTicketTO.numberOfMatches;
    // } else {
    //   const systemIndex = plTicketTO.system.indexOf('System');
    //   if (systemIndex > -1) {
    //     const sysEvCountStringList = plTicketTO.system.substring(systemIndex + 7, plTicketTO.system.indexOf('/')).replace(/ /g, '').split(',');
    //     systemEventsInCombination = sysEvCountStringList.map(n => +n);
    //     systemEventsCount = plTicketTO.numberOfMatches;
    //   }

    //   const fixIndex = plTicketTO.system.indexOf('Fix');
    //   if (fixIndex > -1) {
    //     fixEventsCount = +plTicketTO.system.substring(fixIndex + 4, plTicketTO.system.indexOf(',')).replace(/ /g, '');
    //     systemEventsCount -= fixEventsCount;
    //   }
    // }

    for (const groupTO of plTicketTO.groups) {
      if (groupTO.typeId == GroupTypeList.Fix || groupTO.typeId == GroupTypeList.Fix) {
        fixEventsCount += groupTO.ticketItems.length;
      } else {
        const systems: string[] = groupTO.k.split(';');
        systemEventsInCombination = systems.map(s => +(s.trim()));
        systemEventsCount += groupTO.ticketItems.length;
      }
      groupTO.ticketItems.forEach(ti => {
        let ev = events.find(e => e.id === ti.eventId);
        if (!ev) {
          ev = this.mapPlayedTicketEvent(ti);
          events.push(ev);
        }
        ev.outcomes.push(this.mapPlayedTicketOutcome(ti, betTypeShowTypes[ti.betTypeId]));
      });
    }

    if (events || events.length > 1) {
      events.sort((e1, e2) => {
        if (e1.dateTime > e2.dateTime) {
          return 1;
        }
        if (e1.dateTime < e2.dateTime) {
          return -1;
        }
        return 0;
      });
    }

    return {
      id: plTicketTO.ticketId,
      ticketNumber: plTicketTO.ticketNumber,
      createdOn,
      numberOfMatches: plTicketTO.numberOfMatches,
      numberOfCombinations: plTicketTO.numberOfCombinations,
      type: plTicketTO.type,
      stake: plTicketTO.stake,
      possibleMinWin: plTicketTO.possibleMinWin,
      possibleMaxWin: plTicketTO.possibleMaxWin,
      totalOdd: plTicketTO.quota,
      system: plTicketTO.system,
      bonus: plTicketTO.bonus,
      status: this.mapPlayedTicketState(plTicketTO.status),
      events,
      createdOnDate: createdOn.toLocaleString(this.languageCulture, { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' }),
      createdOnTime: createdOn.toLocaleString(this.languageCulture, { minute: '2-digit', hour: '2-digit' }),
      cashoutValue: plTicketTO.casheback,
      roundedCashoutValue: plTicketTO.roundedCasheback,
      blockedForSell: plTicketTO.blockedForSell,
      jackTimeId: plTicketTO.jackTimeId,
      payin: plTicketTO.payin,
      taxBeforeStake: plTicketTO.taxBeforeStake,
      possiblePayout: plTicketTO.possiblePayout,
      possibleMinPayout: plTicketTO.possibleMinPayout,
      taxOnWinning: plTicketTO.taxOnWinning,
      taxOnMinWinning: plTicketTO.taxOnMinWinning,
      systemEventsCount,
      fixEventsCount,
      systemEventsInCombination,
      eventNames: plTicketTO.eventNames ? plTicketTO.eventNames.join(', ') : '',
      isFreeBet: plTicketTO.isFreeBet,
      createdBy: ticketForUser
    };
  }

  mapPlayedTicketWithGroupsToPlayedTicketTO(ticketWithGroups: IPlayedTicketWithGroupsTO): IPlayedTicketTO {
    let ticketItems = [];

    for (const group of ticketWithGroups.groups) {
      ticketItems = ticketItems.concat(group.ticketItems);
    }

    return {
      ticketId: ticketWithGroups.ticketId,
      jackTimeId: ticketWithGroups.jackTimeId,
      ticketNumber: ticketWithGroups.ticketNumber,
      createdOn: ticketWithGroups.createdOn,
      numberOfMatches: ticketWithGroups.numberOfMatches,
      numberOfCombinations: ticketWithGroups.numberOfCombinations,
      type: ticketWithGroups.type,
      stake: ticketWithGroups.stake,
      possibleMinWin: ticketWithGroups.possibleMinWin,
      possibleMaxWin: ticketWithGroups.possibleMaxWin,
      quota: ticketWithGroups.quota,
      bonus: ticketWithGroups.bonus,
      system: ticketWithGroups.system,
      status: ticketWithGroups.status,
      ticketItems,
      casheback: ticketWithGroups.casheback,
      roundedCasheback: ticketWithGroups.roundedCasheback,
      blockedForSell: ticketWithGroups.blockedForSell,
      dividedTicketsCount: ticketWithGroups.dividedTicketsCount,
      minOdd: ticketWithGroups.minOdd,
      payin: ticketWithGroups.payin,
      taxBeforeStake: ticketWithGroups.taxBeforeStake,
      possiblePayout: ticketWithGroups.possiblePayout,
      possibleMinPayout: ticketWithGroups.possibleMinPayout,
      taxOnWinning: ticketWithGroups.taxOnWinning,
      taxOnMinWinning: ticketWithGroups.taxOnMinWinning,
      eventNames: ticketWithGroups.eventNames,
      isFreeBet: ticketWithGroups.isFreeBet
    };
  }

  mapPlayedTicketEvent(plTicketItem: IPlayedTicketItemTO | IPlayedTicketItemTOsbv): IPlayedTicketEvent {
    // later remove z
    const evDate: Date = new Date(plTicketItem.time.replace('Z', '') + 'Z');
    const teams = plTicketItem.name.split(' - ');
    const homeSetScore = [];
    const awaySetScore = [];
    let homeScore = '';
    let awayScore = '';
    if (plTicketItem.result) {
      const tmpScore: string[] = plTicketItem.result.split('(');
      homeScore = tmpScore[0].split(':')[0];
      awayScore = tmpScore[0].split(':')[1];
      if (tmpScore[1]) {
        const tmpSetScoreReplace: string = tmpScore[1].replace('(', '').replace(')', '');
        const tmpSetScore: string[] = tmpSetScoreReplace.split(' - ');
        if (tmpSetScore.length > 0) {
          tmpSetScore.forEach(singleSet => {
            const singleSetScore = singleSet.split(':');
            homeSetScore.push(singleSetScore[0]);
            awaySetScore.push(singleSetScore[1]);
          });
        }
      }
    }

    if (plTicketItem?.score?.liveScore) {
      const setScores: string[] = plTicketItem.score?.liveSetScore?.replace(' ', '').split('-');
      homeScore = plTicketItem.score?.liveScore?.replace(' ', '').split(':')[0];
      awayScore = plTicketItem.score?.liveScore?.replace(' ', '').split(':')[1];
      setScores?.forEach(setScore => {
        const singleSetScore = setScore.split(':');
        homeSetScore.push(singleSetScore[0]);
        awaySetScore.push(singleSetScore[1]);
      });
    }

    return {
      id: plTicketItem.eventId,
      code: plTicketItem.code,
      dateTime: evDate,
      name: plTicketItem.name,
      homeTeam: teams[0],
      awayTeam: teams[1],
      competitionId: plTicketItem.competitionId,
      competition: plTicketItem.competition,
      regionId: plTicketItem.regionId,
      region: plTicketItem.region,
      sportId: plTicketItem.sportId,
      sport: plTicketItem.sport,
      // betId: plTicketItem.betId,
      result: plTicketItem.result,
      system: plTicketItem.system,
      outcomes: [],
      // dateTimeShort: !this.utilityService.mobileView ?
      //   evDate.toLocaleString(this.languageCulture, { weekday: 'short', minute: '2-digit', hour: '2-digit' }) :
      //   evDate.toLocaleString(this.languageCulture, { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', minute: '2-digit', hour: '2-digit' }),
      dateTimeShort: evDate.toLocaleString(this.languageCulture, { weekday: 'short', minute: '2-digit', hour: '2-digit' }),
      // betOutcomeId: plTicketItem.betOutcomeId,
      eventMappingType: plTicketItem.eventMappingType,
      liveScore: plTicketItem.score?.liveScore ? { homeScore, awayScore, homeSetScore, awaySetScore } : null,
      scores: plTicketItem.score?.scores?.length > 0 ? this.mapTicketEventResults(plTicketItem.score.scores) : [],
      isLive: !!plTicketItem.isLive,
      eventType: plTicketItem.eventType
    };
  }

  mapPlayedTicketOutcome(plTicketItem: IPlayedTicketItemTO | IPlayedTicketItemTOsbv, betTypeShowType: IBetTypeShowType): IPlayedTicketOutcome {
    const sbv1 = (plTicketItem as IPlayedTicketItemTO).sBV;
    const sbv2 = (plTicketItem as IPlayedTicketItemTOsbv).sbv;

    return {
      betTypeName: plTicketItem.betTypeName,
      betName: plTicketItem.betName ?? plTicketItem.betTypeName,
      sbv: sbv1 ? sbv1 : sbv2 ? sbv2 : null,
      betTypeOutcomeName: plTicketItem.betTypeOutcomeName,
      odd: plTicketItem.odd,
      status: this.mapPlayedTicketState(plTicketItem.status),
      betTypeId: plTicketItem.betTypeId,
      betTypeOutcomeId: plTicketItem.betTypeOutcomeId,
      betOutcomeId: plTicketItem.betOutcomeId,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe,
      betId: plTicketItem.betId,
      isLive: !!plTicketItem.isLive
    };
  }

  mapPlayedTicketState(stateTO: IPlayedTicketStateTO): IPlayedTicketState {
    return stateTO;
  }

  mapTicketItemGroup(event: EventVM, languageCulture: string): ITicketItemGroup {
    return {
      sportName: event.sportName,
      regionName: event.regionName,
      competitionName: event.competitionName,
      sportId: event.sportId,
      regionId: event.regionId,
      competitionId: event.competitionId,
      eventId: event.id,
      eventName: event.eventName,
      eventCode: event.code,
      eventHomeTeam: event.homeTeam,
      eventAwayTeam: event.awayTeam,
      eventDateTime: event.dateTime,
      eventDate: event.dateTime.toLocaleDateString(languageCulture, { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' }),
      eventDayShort: event.dateTime.toLocaleDateString(languageCulture, { weekday: 'short' }),
      eventTime: event.dateTime.toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' }),
      mappingType: event.mappingType,
      isInBankersGroup: false,
      ticketItems: {},
      isEventPlayable: event.isPlayable && event.isInOffer,
      siblingEventId: event.siblingdEventId,
      isLive: event.isLive,
      eventType: event.eventType,
      result: null,
      liveScore: null,
      betRadarEventId: event.betRadarEventId,
      scores: null
    };
  }

  mapTicketDialogModelForConfirmation(
    ticketItemGroupsInTicket: { [eventId: number]: ITicketItemGroup },
    ticketType: TicketPlayType,
    ticketData: ITicketData,
    isFix: boolean,
    minOddsSysEvIdsByOddLowToHiWithoutBankers: { [eventId: number]: number },
    maxOddsSysEvIdsByOddHiToLowWithoutBankers: { [eventId: number]: number },
    validationMode?: OddsValidationMode,
    isMultiplayBanker?,
    isMultiplaySystem?,
    systemOptions?: ISystemOption[],
    placeBetType?: TypeOfPlaceBetTicket,
  ): ITicketDialogModel {

    const ticketDialogModel: ITicketDialogModel = {} as ITicketDialogModel;

    ticketDialogModel.isOnline = true;
    ticketDialogModel.ticketItemEventGroups = {};
    ticketDialogModel.systemTicketItemGroups = [];
    ticketDialogModel.bankerTicketItemGroups = [];
    ticketDialogModel.minOddsSysEvIdsByOddLowToHiWithoutBankers = minOddsSysEvIdsByOddLowToHiWithoutBankers;
    ticketDialogModel.maxOddsSysEvIdsByOddHiToLowWithoutBankers = maxOddsSysEvIdsByOddHiToLowWithoutBankers;
    ticketData.hasLowerOdds = false;
    ticketDialogModel.hasLiveItems = false;
    const eventIds = Object.keys(ticketItemGroupsInTicket);
    for (const evId of eventIds) {
      const groupCopy = this.copyTicketItemEventGroup(ticketItemGroupsInTicket[evId]);
      if (groupCopy.isLive) {
        ticketDialogModel.hasLiveItems = true;
      }
      ticketDialogModel.ticketItemEventGroups[groupCopy.eventId] = groupCopy;
      if (groupCopy.isInBankersGroup || ticketDialogModel.isFix) {
        ticketDialogModel.bankerTicketItemGroups.push(groupCopy);
      } else {
        ticketDialogModel.systemTicketItemGroups.push(groupCopy);
      }

      if (ViewConfigurations.showDialogOnOddChangeBeforePlaceBet) {
        for (const ticketItem of Object.values(ticketItemGroupsInTicket[+evId].ticketItems)) {
          if (ticketItem.odd < ticketItem.oldOdd) {
            ticketData.hasLowerOdds = true;
          }
        }
      }
    }
    ticketDialogModel.ticketType = ticketType;
    ticketDialogModel.validationMode = validationMode ? validationMode : OddsValidationMode.AcceptAllOdds;
    ticketDialogModel.ticketData = this.copyTicketData(ticketData);
    ticketDialogModel.ticketItemsLength = eventIds.length;
    ticketDialogModel.isFix = isFix;

    ticketDialogModel.isMultiplayBanker = isMultiplayBanker;
    ticketDialogModel.isMultiplaySystem = isMultiplaySystem;
    ticketDialogModel.systemOptions = systemOptions;
    // use only for authorization
    ticketDialogModel.requestedTotalOdd = ticketData.totalOdd;
    ticketDialogModel.requestedStake = ticketData.totalStake;
    ticketDialogModel.typeOfPlaceBetTicket = placeBetType;

    // console.log(ticketDialogModel.ticketItemEventGroups);
    return ticketDialogModel;

  }

  copyTicketData(ticketData: ITicketData): ITicketData {
    return {
      isTicketOnline: ticketData.isTicketOnline,
      numberOfBets: ticketData.numberOfBets,
      totalStake: ticketData.totalStake,
      wagerPerBet: ticketData.wagerPerBet,
      totalWinings: ticketData.totalWinings,
      minWinings: ticketData.minWinings,
      totalOdd: ticketData.totalOdd,
      minOdd: ticketData.minOdd,
      possibleWin: ticketData.possibleWin,
      bonus: ticketData.bonus,
      bonusPercent: ticketData.bonusPercent,
      freeBetValue: ticketData.freeBetValue,
      freeBetValueToShow: ticketData.freeBetValueToShow,
      payin: ticketData.payin,
      taxBeforeStake: ticketData.taxBeforeStake,
      taxOnWinings: ticketData.taxOnWinings,
      possibleWinWithoutTax: ticketData.possibleWinWithoutTax,
      possiblePayout: ticketData.possiblePayout,
      possibleMinPayout: ticketData.possibleMinPayout,
      taxOnMinWinning: ticketData.taxOnMinWinning,
      hasLowerOdds: ticketData.hasLowerOdds,
      oddsForNumberOfHits: ticketData.oddsForNumberOfHits,
      possibleWinForNumberOfHits: ticketData.possibleWinForNumberOfHits
    };
  }

  copyTicketItemEventGroup(group: ITicketItemGroup): ITicketItemGroup {
    const ticketItems: { [betOutcomeId: number]: ITicketItem } = {};
    for (const [k, ti] of Object.entries(group.ticketItems)) {
      ticketItems[ti.betOutcomeId] = this.copyTicketItem(ti);
    }
    return {
      sportName: group.sportName,
      regionName: group.regionName,
      competitionName: group.competitionName,
      sportId: group.sportId,
      regionId: group.regionId,
      competitionId: group.competitionId,
      eventId: group.eventId,
      eventName: group.eventName,
      eventCode: group.eventCode,
      eventHomeTeam: group.eventHomeTeam,
      eventAwayTeam: group.eventAwayTeam,
      eventDateTime: group.eventDateTime,
      eventDate: group.eventDate,
      eventTime: group.eventTime,
      eventDayShort: group.eventDayShort,
      mappingType: group.mappingType,
      isInBankersGroup: group.isInBankersGroup,
      ticketItems,
      isEventPlayable: group.isEventPlayable,
      siblingEventId: group.siblingEventId,
      isLive: group.isLive,
      eventType: group.eventType,
      result: group.result,
      liveScore: group.liveScore,
      betRadarEventId: group.betRadarEventId,
      scores: group.scores
    };
  }

  copyTicketItem(ticketItem: ITicketItem): ITicketItem {
    return {
      sbv: ticketItem.sbv,
      odd: ticketItem.odd,
      oldOdd: ticketItem.oldOdd,
      betId: ticketItem.betId,
      betOutcomeId: ticketItem.betOutcomeId,
      betTypeId: ticketItem.betTypeId,
      betTypeName: ticketItem.betTypeName,
      betName: ticketItem.betName ?? ticketItem.betTypeName,
      betTypeOutcomeId: ticketItem.betTypeOutcomeId,
      betOutcomeName: ticketItem.betOutcomeName,
      isLive: ticketItem.isLive,
      isBetOutcomePlayable: ticketItem.isBetOutcomePlayable,
      isBetPlayable: ticketItem.isBetPlayable,
      status: ticketItem.status,
      useSbvHandicapPipe: ticketItem.useSbvHandicapPipe
    };
  }

  createTicketItemGroupFromTicketItemForTicket(ticketItem: ITicketItemForTicket, languageCulture: string): ITicketItemGroup {
    const tmpNames: string[] = ticketItem.eventName.split(' - ');
    const homeTeam = tmpNames[0];
    const awayTeam = tmpNames[1];
    return {
      sportName: ticketItem.sportName,
      regionName: ticketItem.regionName,
      competitionName: ticketItem.competitionName,
      sportId: ticketItem.sportId,
      regionId: ticketItem.regionId,
      competitionId: ticketItem.competitionId,
      eventId: ticketItem.eventId,
      eventName: ticketItem.eventName,
      eventCode: ticketItem.eventCode,
      eventHomeTeam: homeTeam,
      eventAwayTeam: awayTeam,
      eventDateTime: ticketItem.eventDateTime,
      eventDate: ticketItem.eventDateTime.toLocaleDateString(languageCulture, { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit' }),
      eventTime: ticketItem.eventDateTime.toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' }),
      eventDayShort: ticketItem.eventDateTime.toLocaleDateString(languageCulture, { weekday: 'short' }),
      mappingType: ticketItem.mappingType,
      isInBankersGroup: false,
      ticketItems: {},
      isEventPlayable: ticketItem.isEventPlayable,
      siblingEventId: null,
      isLive: ticketItem.isLive,
      eventType: EventType.HeadToHead,
      result: null,
      liveScore: null,
      betRadarEventId: null,
      scores: null
    };
  }


  createTicketItemFromTicketItemForTicket(ti: ITicketItemForTicket): ITicketItem {
    return {
      sbv: ti.sbv,
      odd: ti.acceptedOdd,
      oldOdd: ti.requestedOdd > 0 ? ti.requestedOdd : ti.acceptedOdd,
      betId: ti.betId,
      betOutcomeId: ti.betOutcomeId,
      betTypeId: ti.betTypeId,
      betTypeName: ti.betTypeName,
      betName: ti.betTypeName,
      betTypeOutcomeId: ti.betTypeOutcomeId,
      betOutcomeName: ti.betTypeOutcomeName,
      isLive: ti.isLive,
      isBetOutcomePlayable: ti.isPlayable,
      isBetPlayable: ti.isPlayable,
      // higherLowerOdd: ti.requestedOdd > ti.acceptedOdd ? BetOutcomeOddDifference.Lower : ti.requestedOdd < ti.acceptedOdd ? BetOutcomeOddDifference.Lower : BetOutcomeOddDifference.None,
      status: TicketStatus.Pending,
      useSbvHandicapPipe: ti.useSbvHandicapPipe
    };
  }

  mapEventFromTicketItemGroup(group: ITicketItemGroup, languageCulture: string): EventVM {
    const event = new EventVM();

    event.sportName = group.sportName;
    event.regionName = group.regionName;
    event.competitionName = group.competitionName;
    event.sportId = group.sportId;
    event.regionId = group.regionId;
    event.competitionId = group.competitionId;
    event.id = group.eventId;
    event.eventName = group.eventName;
    event.code = group.eventCode;
    event.homeTeam = group.eventHomeTeam;
    event.awayTeam = group.eventAwayTeam;
    event.dateTime = group.eventDateTime;
    event.eventDate = group.eventDateTime.toLocaleDateString(languageCulture, { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' });
    event.eventTime = group.eventDateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' });
    event.mappingType = group.mappingType;
    event.isPlayable = group.isEventPlayable;
    event.isInOffer = group.isEventPlayable;
    event.siblingdEventId = group.siblingEventId;
    event.isLive = group.isLive;
    event.eventType = group.eventType;
    event.betRadarEventId = group.betRadarEventId;
    event.specialOfferType = this.utilityService.getSpecialOfferType(group.mappingType, group.eventType);
    return event;
  }

  mapEventResultFromTicketItemGroup(group: ITicketItemGroup, languageCulture: string): IEventResult {
    const results: { [groupId: number]: IGroupResult } = {};
    for (const resultGroup of group.scores) {
      results[resultGroup.scoreGroupId] = this.mapGroupResultFromTicketResultGroup(resultGroup);
    }

    return {
      eventId: group.eventId,
      eventCode: group.eventCode,
      eventDateTime: group.eventDateTime,
      competitionId: group.competitionId,
      regionId: group.regionId,
      sportId: group.sportId,
      competitionName: group.competitionName,
      eventName: group.eventName,
      betGroups: {},
      homeTeam: group.eventHomeTeam,
      awayTeam: group.eventAwayTeam,
      homeTeamShort: group.eventHomeTeam.substring(0, 2),
      awayTeamShort: group.eventAwayTeam.substring(0, 2),
      results,
      regionName: group.regionName,
      sportName: group.sportName,
      isExpanded: false,
      eventDate: group.eventDateTime.toLocaleDateString(languageCulture, { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' }),
      eventTime: group.eventDateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' }),
      eventType: EventType.HeadToHead,
    };
  }

  mapEventResultFromPlayedTicketEvent(playedTicektEvent: IPlayedTicketEvent, languageCulture: string): IEventResult {
    const results: { [groupId: number]: IGroupResult } = {};
    for (const resultGroup of playedTicektEvent.scores) {
      results[resultGroup.scoreGroupId] = this.mapGroupResultFromTicketResultGroup(resultGroup);
    }

    return {
      eventId: playedTicektEvent.id,
      eventCode: playedTicektEvent.code,
      eventDateTime: playedTicektEvent.dateTime,
      competitionId: playedTicektEvent.competitionId,
      regionId: playedTicektEvent.regionId,
      sportId: playedTicektEvent.sportId,
      competitionName: playedTicektEvent.competition,
      eventName: playedTicektEvent.name,
      betGroups: {},
      homeTeam: playedTicektEvent.homeTeam,
      awayTeam: playedTicektEvent.awayTeam,
      homeTeamShort: playedTicektEvent.homeTeam.substring(0, 2),
      awayTeamShort: playedTicektEvent.awayTeam.substring(0, 2),
      results,
      regionName: playedTicektEvent.region,
      sportName: playedTicektEvent.sport,
      isExpanded: false,
      eventDate: playedTicektEvent.dateTime.toLocaleDateString(languageCulture, { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' }),
      eventTime: playedTicektEvent.dateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' }),
      eventType: EventType.HeadToHead,
    };
  }

  mapGroupResultFromTicketResultGroup(ticketResultGroup: ITicketResultGroup): IGroupResult {
    return {
      hasHomeAway: ticketResultGroup.hasHomeAway,
      scorePeriods: ticketResultGroup.scorePeriods,
      scoreGroupId: ticketResultGroup.scoreGroupId
    };
  }

  mapTicketItem(eventType: EventType, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string): ITicketItem {
    return {
      sbv: bet.sbv,
      odd: outcome.odd,
      oldOdd: outcome.odd,
      betId: outcome.betId,
      betOutcomeId: outcome.id,
      betTypeId: outcome.betTypeId,
      betTypeName: eventType === EventType.HeadToHead ? betTypeName : bet.outrightName,
      betName: eventType === EventType.HeadToHead ? betTypeName : bet.outrightName,
      betTypeOutcomeId: outcome.betTypeOutcomeId,
      betOutcomeName: eventType === EventType.HeadToHead ? betTypeOutcomeName : outcome.name,
      isLive: outcome.isLive,
      isBetOutcomePlayable: outcome.isPlayable,
      isBetPlayable: bet.isPlayable,
      // higherLowerOdd: outcome.higherLowerOdd,
      status: TicketStatus.Pending,
      useSbvHandicapPipe: bet.useSbvHandicapPipe
    };
  }

  mapUpdateTicketRequestObjTO(ticketItemGroup: ITicketItemGroup, ticketItem: ITicketItem): IUpdateTicketRequestObjTO {
    return {
      sportId: ticketItemGroup.sportId,
      regionId: ticketItemGroup.regionId,
      competitionId: ticketItemGroup.competitionId,
      eventId: ticketItemGroup.eventId,
      betId: ticketItem.betId,
      betOutcomeId: ticketItem.betOutcomeId
    };
  }

  mapMultiwayRestrictionItem(multiwayRestrictionItemTO: IMultiwayRestrictionItemTO): IMultiwayRestrictionItem {
    return multiwayRestrictionItemTO;
  }

  mapMultiwayRestriction(multiwayRestrictionTO: IMultiwayRestrictionTO): IMultiwayRestriction {
    return multiwayRestrictionTO;
  }

  mapBonusSettings(bonusSettingsTO: IBonusSettingsTO): IBonusSettings {
    return {
      betslipType: bonusSettingsTO.betslipType,
      bonus: bonusSettingsTO.bonus,
      deleted: bonusSettingsTO.deleted,
      eventType: bonusSettingsTO.eventType,
      fromDate: new Date(bonusSettingsTO.fromDate.replace('Z', '') + 'Z'),
      toDate: bonusSettingsTO.toDate? new Date(bonusSettingsTO.toDate.replace('Z', '') + 'Z'): null,
      fromSelections: bonusSettingsTO.fromSelections,
      fromStake: bonusSettingsTO.fromStake,
      happyHourFrom: bonusSettingsTO.happyHourFrom,
      happyHourTo: bonusSettingsTO.happyHourTo,
      id: bonusSettingsTO.iD,
      isAllEventSelected: bonusSettingsTO.isAllEventSelected,
      isHappyHour: bonusSettingsTO.isHappyHour,
      minimumEventOdd: bonusSettingsTO.minimumEventOdd,
      minimumEventOddMode: bonusSettingsTO.minimumEventOddMode,
      minimumGlobalOdd: bonusSettingsTO.minimumGlobalOdd,
      name: bonusSettingsTO.name,
      note: bonusSettingsTO.note,
      officeId: bonusSettingsTO.officeId,
      sportCondition: bonusSettingsTO.sportCondition,
      toSelections: bonusSettingsTO.toSelections,
      toStake: bonusSettingsTO.toStake,
      hierarchies: bonusSettingsTO.hierarchies.map(h => this.mapBonusSettingHierarchy(h)),
    };
  }

  mapBonusSettingHierarchy(bsHierachyTO: IBonusSettingHierarchyTO): IBonusSettingHierarchy {
    return {
      bonusSettingId: bsHierachyTO.bonusSettingId,
      competitionId: bsHierachyTO.competitionId,
      id: bsHierachyTO.id,
      regionId: bsHierachyTO.regionId,
      sportId: bsHierachyTO.sportId
    };
  }

  mapFreeBetSetting(fbSettingTO: IFreeBetSettingTO): IFreeBetSetting {
    return {
      acountPermission: fbSettingTO.acountPermission,
      betslipType: fbSettingTO.betslipType,
      deleted: fbSettingTO.deleted,
      eventType: fbSettingTO.eventType,
      // later remove z
      fromDate: new Date(fbSettingTO.fromDate.replace('Z', '') + 'Z'),
      id: fbSettingTO.iD,
      includeBonus: fbSettingTO.includeBonus,
      isAllEventsSeleted: fbSettingTO.isAllEventsSeleted,
      minTicketItems: fbSettingTO.minTicketItems,
      name: fbSettingTO.name,
      procesingType: fbSettingTO.procesingType,
      sportTreeCondition: fbSettingTO.sportTreeCondition,
      // later remove z
      toDate: new Date(fbSettingTO.toDate.replace('Z', '') + 'Z'),
      updatedOn: fbSettingTO.updatedOn,
      hierarchies: fbSettingTO.hierarchies.map(h => this.mapFreeBetSettingHierarchy(h)),
      toStake: fbSettingTO.toStake,
      minimumEventOdd: fbSettingTO.minimumEventOdd,
      minimumGlobalOdd: fbSettingTO.minimumGlobalOdd,
      fromStake: fbSettingTO.fromStake,
      minimumRestItemsOdd: fbSettingTO.minimumRestItemsOdd
    };
  }

  mapFreeBetSettingHierarchy(fbsettingHierarchyTO: IFreeBetSettingHierarchyTO): IFreeBetSettingHierarchy {
    return {
      id: fbsettingHierarchyTO.id,
      sportId: fbsettingHierarchyTO.sportId,
      freeBetSettingId: fbsettingHierarchyTO.freeBetSettingId,
      regionId: fbsettingHierarchyTO.regionId,
      competitionId: fbsettingHierarchyTO.competitionId,
      eventId: fbsettingHierarchyTO.eventId,
    };
  }

  createTicket(
    typeOfTicket: TicketType,
    noCombination: number,
    groups: ITicketGroup[],
    possibleWinWithoutBonus: number,
    possibleWin: number,
    stake: number,
    odd: number,
    isLive: boolean,
    bonus: number,
    bonusPercent: number,
    minOdd: number,
    minWinings: number,
    freeBetVal: number,
    ticketTypeName: string,
    taxBeforeStake: number,
    taxOnWinning: number,
    payin: number,
    fbprocessingType?: FreeBetProcessingType,
    possibleWinWithoutTax?: number,
    possiblePayout?: number,
    possibleMinPayout?: number,
    taxOnMinWinning?: number
  ): ITicket {

    return {
      typeOfTicket,
      numOfCombinations: noCombination,
      groups,
      possibleWinWithoutBonus,
      possibleWin,
      overGroupK: '0',
      totalStake: stake,
      totalOdd: odd,
      maxPayout: ConstantValues.MAX_PAY_OUT,
      taxBeforeStake,
      taxOnWinning,
      isLive,
      bonus,
      bonusPercent,
      minOdd,
      minWinings,
      freeBetProcessingType: fbprocessingType,
      freeBetValue: freeBetVal,
      ticketTypeName,
      payin,
      possibleWinWithoutTax,
      possiblePayout,
      possibleMinPayout,
      taxOnMinWinning,
    } as ITicket;
  }

  createTicketItemForTicket(ticketItemGroup: ITicketItemGroup, ticketItem: ITicketItem): ITicketItemForTicket {
    const betValue: IBetValue = {} as IBetValue;
    if (ticketItem.sbv) {
      if (ticketItem.isLive) {
        if (ticketItem.sbv) {
          betValue.liveSpecialBetValue = ticketItem.sbv;
        } else {
          if (!isNaN(ticketItem.sbv)) {
            betValue.value = Number(ticketItem.sbv);
          }
        }
      }
    }
    return {
      sbv: ticketItem.sbv,
      acceptedOdd: ticketItem.odd,
      competitionId: ticketItemGroup.competitionId,
      sportName: ticketItemGroup.sportName,
      regionName: ticketItemGroup.regionName,
      competitionName: ticketItemGroup.competitionName,
      betId: ticketItem.betId,
      sportId: ticketItemGroup.sportId,
      regionId: ticketItemGroup.regionId,
      betOutcomeId: ticketItem.betOutcomeId,
      betTypeId: ticketItem.betTypeId,
      betTypeName: ticketItem.betTypeName,
      betTypeOutcomeId: ticketItem.betTypeOutcomeId,
      betTypeOutcomeName: ticketItem.betOutcomeName,
      eventCode: ticketItemGroup.eventCode,
      eventDateTime: ticketItemGroup.eventDateTime,
      eventId: ticketItemGroup.eventId,
      isAH: false,
      isFix: false,
      statusId: 1,
      ticketId: 1,
      updatedDateTime: new Date(),
      eventName: ticketItemGroup.eventName,
      isLive: ticketItem.isLive,
      betValues: ticketItem.sbv != null && ticketItem.sbv !== undefined ? [betValue] : null,
      requestedOdd: ticketItem.odd,
      mappingType: ticketItemGroup.mappingType,
      isPlayable: ticketItem.isBetOutcomePlayable,
      isBetPlayable: ticketItem.isBetPlayable,
      isEventPlayable: ticketItemGroup.isEventPlayable,
      useSbvHandicapPipe: ticketItem.useSbvHandicapPipe
    };
  }

  mapJTBetPoint(jtBetPointTO: IJTBetPointTO): IJTBetPoint {
    return {
      blockedForSell: jtBetPointTO.blockedForSell,
      exchangeValue: jtBetPointTO.exchangeValue,
      timestamp: jtBetPointTO.timestamp,
      roundedExchangeValue: jtBetPointTO.roundedExchangeValue
    };
  }

  mapBetHistoryJTResponse(betHistoryResponseTO: IBetHistoryJTResponseTO): IBetHistoryJTResponse {
    return {
      betpoints: betHistoryResponseTO.betpoints,
      lastIndex: betHistoryResponseTO.lastIndex
    };
  }

  mapRemoteOperationResult(remoteOperationResultTO: IRemoteOperationResultTO): IRemoteOperationResult {
    return {
      success: remoteOperationResultTO.success,
      message: remoteOperationResultTO.message,
      restServiceMessage: remoteOperationResultTO.rESTServiceMessage,
    };
  }

  mapSellBetResponse(selBetResponseTO: ISellBetResponseTO): ISellBetResponse {
    return {
      ammount: selBetResponseTO.ammount,
      generatedValueTicketId: selBetResponseTO.generatedValueTicketId,
      remoteOperationResult: this.mapRemoteOperationResult(selBetResponseTO.remoteOperationResult),
      updatedCashoutValue: selBetResponseTO.updatedCashoutValue,
    };
  }


  mapSellBetResponseTM(selBetResponseTmTO: ISellBetResponseTmTO): ISellBetResponseTm {
    return {
      data: selBetResponseTmTO.data,
      isSuccess: selBetResponseTmTO.isSuccess,
      failureReason: selBetResponseTmTO.failureReason
    };
  }

  mapTicketValidationResult(ticketValidationResultTO: ITicketValidationResultTO, officeId: number, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): ITicketValidationResult {
    return {
      confirmedTicket: ticketValidationResultTO.confirmedTicket ? this.mapTicket(ticketValidationResultTO.confirmedTicket, officeId, betTypeShowTypes) : null,
      message: ticketValidationResultTO.message,
      remoteOperationResult: this.mapRemoteOperationResult(ticketValidationResultTO.remoteOperationResult),
      ticketId: ticketValidationResultTO.ticketId,
      validatedTicket: ticketValidationResultTO.validatedTicket,
    };
  }

  mapTicketGroup(ticketGroupTO: ITicketGroupTO, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): ITicketGroup {
    const ticketItems: { [ticketItemId: number]: ITicketItemForTicket } = {};
    Object.entries(ticketGroupTO.ticketItems).forEach(([k, ti]) => {
      ticketItems[k] = this.mapTicketItemItemForTicket(ti, betTypeShowTypes[ti.betTypeID]);
    });
    return {
      hasMultipleOutcomes: ticketGroupTO.hasMultipleOutcomes,
      id: ticketGroupTO.id,
      k: ticketGroupTO.k,
      n: ticketGroupTO.n,
      ticketItems,
      typeId: ticketGroupTO.typeId,
      groupType: ticketGroupTO.groupType,
    };
  }

  mapTicketGroupFromExpress(ticketGroupTO: IExpressTicketItemGroupTO, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): ITicketGroup {
    const ticketItems: { [ticketItemId: number]: ITicketItemForTicket } = {};
    for (const ti of ticketGroupTO.ticketItems) {
      ticketItems[ti.betOutcomeId] = this.mapTicketItemItemFromExpress(ti, betTypeShowTypes[ti.betTypeId]);
    }
    return {
      hasMultipleOutcomes: ticketGroupTO.hasMultipleOutcomes,
      id: ticketGroupTO.id,
      k: ticketGroupTO.k,
      n: ticketGroupTO.n,
      ticketItems,
      typeId: ticketGroupTO.typeId,
      groupType: ticketGroupTO.typeId,
    };
  }

  mapTicketItemItemFromExpress(itemForTicketTO: IExpressTicketItemTO, betTypeShowType: IBetTypeShowType): ITicketItemForTicket {

    return {
      sbv: itemForTicketTO.sbv,
      acceptedOdd: itemForTicketTO.acceptedOdd,
      competitionId: itemForTicketTO.competitionId,
      sportName: itemForTicketTO.sportName,
      regionName: itemForTicketTO.regionName,
      competitionName: itemForTicketTO.competitionName,
      betId: itemForTicketTO.betId,
      sportId: itemForTicketTO.sportId,
      regionId: itemForTicketTO.regionId,
      betOutcomeId: itemForTicketTO.betOutcomeId,
      betTypeId: itemForTicketTO.betTypeId,
      betTypeName: itemForTicketTO.betName,
      betTypeOutcomeId: itemForTicketTO.betTypeOutcomeId,
      betTypeOutcomeName: itemForTicketTO.betOutcomeName,
      eventCode: itemForTicketTO.eventCode,
      // later remove z
      eventDateTime: new Date(itemForTicketTO.eventDateTime.replace('Z', '') + 'Z'),
      eventId: itemForTicketTO.eventId,
      // later remove z
      updatedDateTime: itemForTicketTO.eventDateTime ? new Date(itemForTicketTO.eventDateTime.replace('Z', '') + 'Z') : new Date(),
      eventName: itemForTicketTO.eventName,
      isLive: itemForTicketTO.isLive,
      requestedOdd: itemForTicketTO.acceptedOdd,
      mappingType: itemForTicketTO.eventMappingType,
      isPlayable: true,
      isBetPlayable: true,
      isEventPlayable: true,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe
    } as ITicketItemForTicket;
  }

  // later remove and make for new model
  mapTicketItemItemForTicket(itemForTicketTO: ITicketItemTO, betTypeShowType: IBetTypeShowType): ITicketItemForTicket {
    let sbv: string;
    if (itemForTicketTO.sbv) {
      sbv = itemForTicketTO.sbv;
    } else if (itemForTicketTO.betValues && itemForTicketTO.betValues.length !== 0) {
      if (itemForTicketTO.betValues[0].value != null) {
        sbv = itemForTicketTO.betValues[0].value.toString();
      } else if (itemForTicketTO.betValues[0].liveSpecialBetValue != null) {
        sbv = itemForTicketTO.betValues[0].liveSpecialBetValue;
      } else {
        sbv = null;
      }
    } else {
      sbv = null;
    }
    return {
      sbv,
      acceptedOdd: itemForTicketTO.acceptedOdd,
      competitionId: itemForTicketTO.competitionId,
      sportName: itemForTicketTO.sportName,
      regionName: itemForTicketTO.regionName,
      competitionName: itemForTicketTO.competitionName,
      betId: itemForTicketTO.betId,
      sportId: itemForTicketTO.sportId,
      regionId: itemForTicketTO.regionId,
      betOutcomeId: itemForTicketTO.betOutcomeId,
      betTypeId: itemForTicketTO.betTypeID,
      betTypeName: itemForTicketTO.betTypeName,
      betTypeOutcomeId: itemForTicketTO.betTypeOutcomeID,
      betTypeOutcomeName: itemForTicketTO.betTypeOutcomeName,
      eventCode: itemForTicketTO.eventCode,
      // later remove z
      eventDateTime: new Date(itemForTicketTO.eventDateTime.replace('Z', '') + 'Z'),
      eventId: itemForTicketTO.eventID,
      isAH: itemForTicketTO.isAH,
      isFix: itemForTicketTO.isFix,
      statusId: itemForTicketTO.statusId,
      ticketId: itemForTicketTO.ticketId,
      // later remove z
      updatedDateTime: itemForTicketTO.updatedDateTime ? new Date(itemForTicketTO.updatedDateTime.replace('Z', '') + 'Z') : new Date(),
      eventName: itemForTicketTO.eventName,
      isLive: itemForTicketTO.isLive,
      betValues: itemForTicketTO.betValues,
      requestedOdd: itemForTicketTO.requestedOdd,
      mappingType: itemForTicketTO.mappingType,
      isPlayable: true,
      isBetPlayable: true,
      isEventPlayable: true,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe
    };
  }
  // later remove and make for new model
  mapTicket(ticketTO: ITicketTO, officeId, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): ITicket {
    if (!ticketTO) {
      return null;
    }
    return {
      acceptedBy: ticketTO.acceptedBy,
      bidderId: ticketTO.bidderId,
      bonusSettingsValue: ticketTO.bonusSettingsValue,
      cacheTime: ticketTO.cacheTime,
      cancelOn: ticketTO.cancelOn,
      bonus: ticketTO.bonus,
      bonusPercent: (ticketTO.bonus / ticketTO.possibleWinWithoutBonus) * 100,
      groups: ticketTO.groups.map((gr) => this.mapTicketGroup(gr, betTypeShowTypes)),
      id: ticketTO.id,
      isLive: ticketTO.isLive,
      isProcessed: ticketTO.isProcessed,
      isTicketVerified: ticketTO.isTicketVerified,
      itemsNumber: ticketTO.itemsNumber,
      maxPayout: ticketTO.maxPayout,
      numOfCombinations: ticketTO.numOfCombinations,
      overGroupK: ticketTO.overGroupK,
      paidBy: ticketTO.paidBy,
      payedAmount: ticketTO.payedAmount,
      // later remove z
      paymentOn: ticketTO.paymentOn ? new Date(ticketTO.paymentOn.replace('Z', '') + 'Z') : null,
      payoutDate: ticketTO.payoutDate ? new Date(ticketTO.payoutDate.replace('Z', '') + 'Z') : null,
      pendingItems: ticketTO.pendingItems,
      pendingOdds: ticketTO.pendingOdds,
      pinCode: ticketTO.pinCode,
      possibleWin: ticketTO.possibleWin,
      possibleWinWithoutBonus: ticketTO.possibleWinWithoutBonus,
      processedTime: ticketTO.processedTime,
      statusId: ticketTO.statusId,
      taxBeforeStake: ticketTO.taxBeforeStake,
      taxBeforeStakePercent: ticketTO.taxBeforeStakePercent,
      taxOnWinning: ticketTO.taxOnWinning,
      ticketDescription: ticketTO.ticketDescription,
      ticketId: ticketTO.ticketId,
      ticketStatus: ticketTO.ticketStatus,
      ticketValidationId: ticketTO.ticketValidationId,
      totalOdd: ticketTO.totalOdd,
      totalStake: ticketTO.totalStake,
      typeOfTicket: ticketTO.typeOfTicket,
      // later remove z
      updatedDateTime: ticketTO.updatedDateTime ? new Date(ticketTO.updatedDateTime.replace('Z', '') + 'Z') : new Date(),
      winOdds: ticketTO.winOdds,
      // Calculate LATER
      eventsCount: 0,
      webPlatformCurrency: ticketTO.webPlatformCurrency,
      webPlatformLanguage: ticketTO.webPlatformLanguage,
      platformCustomerId: ticketTO.platformCustomerId,
      isFastTicket: ticketTO.isFastTicket,
      requestedTotalOdd: ticketTO.requestedTotalOdd,
      requestedStake: ticketTO.requestedStake,
      minOdd: ticketTO.minOdd,
      minWinings: ticketTO.minPossibleWin,
      isFreeBet: ticketTO.isFreeBet,
      freeBetProcessingType: ticketTO.freeBetProcessingType,
      freeBetValue: 0,
      ticketTypeName: '',
      officeId,
      systemName: '',
      payin: ticketTO.payin,
      possibleWinWithoutTax: ticketTO.possibleWinWithoutTax,
      possiblePayout: ticketTO.possiblePayout,
      possibleMinPayout: ticketTO.minPayout,
      taxOnMinWinning: ticketTO.taxOnMinWinning ? ticketTO.taxOnMinWinning : ticketTO.minPayoutTax,
      cashOutValue: 0,
      createdBy: null
    };
  }

  mapExpressTicket(ticketTO: IExpressTicketTO, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): IExpressTicket {
    if (!ticketTO) {
      return null;
    }
    return {
      id: ticketTO.id,
      ticketCode: ticketTO.ticketCode,
      payIn: ticketTO.payIn,
      totalOdd: ticketTO.totalOdd,
      possibleWin: ticketTO.possibleWin,
      typeId: ticketTO.typeId,
      createdAt: ticketTO.createdAt,
      officeId: ticketTO.officeId,
      userId: ticketTO.userId,
      isLive: ticketTO.isLive,
      bidderId: ticketTO.bidderId,
      groups: ticketTO.groups.map((gr) => this.mapTicketGroupFromExpress(gr, betTypeShowTypes)),
    };
  }

  mapTicketTO(ticket: ITicket, officeId: number): ITicketTO {
    return {
      acceptedBy: ticket.acceptedBy,
      bidderId: ticket.bidderId,
      bonusSettingsValue: ticket.bonusSettingsValue,
      bonus: ticket.bonus,
      cacheTime: ticket.cacheTime,
      cancelOn: ticket.cancelOn,
      minPossibleWin: ticket.minWinings,
      groups: ticket.groups.map((gr) => this.mapTicketItemGroupTO(gr)),
      id: ticket.id,
      isLive: ticket.isLive,
      isProcessed: ticket.isProcessed,
      isTicketVerified: ticket.isTicketVerified,
      itemsNumber: ticket.itemsNumber,
      maxPayout: ticket.maxPayout,
      numOfCombinations: ticket.numOfCombinations,
      officeId,
      overGroupK: ticket.overGroupK,
      paidBy: ticket.paidBy,
      // paidOfficeId: ticket.paidOfficeId,
      // payedAccountIdIn: ticket.payedAccountIdIn,
      // payedAccountIdOut: ticket.payedAccountIdOut,
      payedAmount: ticket.payedAmount,
      // later remove replace
      paymentOn: ticket.paymentOn?.toISOString().replace('Z', ''),
      payoutDate: ticket.payoutDate?.toISOString().replace('Z', ''),
      pendingItems: ticket.pendingItems,
      pendingOdds: ticket.pendingOdds,
      pinCode: ticket.pinCode,
      possibleWin: ticket.possibleWin,
      possibleWinWithoutBonus: ticket.possibleWinWithoutBonus,
      processedTime: ticket.processedTime,
      statusId: ticket.statusId,
      taxBeforeStake: ticket.taxBeforeStake,
      taxBeforeStakePercent: ticket.taxBeforeStakePercent,
      taxOnWinning: ticket.taxOnWinning,
      ticketDescription: ticket.ticketDescription,
      ticketId: ticket.ticketId,
      ticketStatus: ticket.ticketStatus,
      ticketValidationId: ticket.ticketValidationId,
      totalOdd: ticket.totalOdd,
      totalStake: ticket.totalStake,
      typeOfTicket: ticket.typeOfTicket,
      // later remove replace
      updatedDateTime: ticket.updatedDateTime?.toISOString().replace('Z', ''),
      winOdds: ticket.winOdds,
      webPlatformCurrency: ticket.webPlatformCurrency,
      webPlatformLanguage: ticket.webPlatformLanguage,
      platformCustomerId: ticket.platformCustomerId,
      isFastTicket: ticket.isFastTicket,
      requestedTotalOdd: ticket.requestedTotalOdd,
      requestedStake: ticket.requestedStake,
      minOdd: ticket.minOdd,
      isFreeBet: ticket.isFreeBet,
      freeBetProcessingType: ticket.freeBetProcessingType,
      payin: ticket.payin,
    } as ITicketTO;
  }
  mapTicketItemGroupTO(ticketGroup: ITicketGroup): ITicketGroupTO {
    const ticketItems: { [ticketItemId: number]: ITicketItemTO } = {};
    Object.entries(ticketGroup.ticketItems).forEach(([k, ti]) => {
      ticketItems[k] = this.mapTicketItemTO(ti);
    });
    return {
      hasMultipleOutcomes: ticketGroup.hasMultipleOutcomes,
      id: ticketGroup.id,
      k: ticketGroup.k,
      n: ticketGroup.n,
      ticketItems,
      typeId: ticketGroup.typeId,
      groupType: ticketGroup.groupType,
      ticketId: 1,
    };
  }

  // later remove and make for new model
  mapTicketItemTO(itemForTicket: ITicketItemForTicket): ITicketItemTO {
    return {
      sbv: itemForTicket.sbv,
      acceptedOdd: itemForTicket.acceptedOdd,
      competitionId: itemForTicket.competitionId,
      sportName: itemForTicket.sportName,
      regionName: itemForTicket.regionName,
      competitionName: itemForTicket.competitionName,
      betId: itemForTicket.betId,
      sportId: itemForTicket.sportId,
      regionId: itemForTicket.regionId,
      betOutcomeId: itemForTicket.betOutcomeId,
      betTypeID: itemForTicket.betTypeId,
      betTypeName: itemForTicket.betTypeName,
      betTypeOutcomeID: itemForTicket.betTypeOutcomeId,
      betTypeOutcomeName: itemForTicket.betTypeOutcomeName,
      eventCode: itemForTicket.eventCode,
      // later remove replace
      eventDateTime: itemForTicket.eventDateTime.toISOString().replace('Z', ''),
      eventID: itemForTicket.eventId,
      isAH: itemForTicket.isAH,
      isFix: itemForTicket.isFix,
      statusId: itemForTicket.statusId,
      ticketId: itemForTicket.ticketId,
      // later remove replace
      updatedDateTime: itemForTicket.updatedDateTime.toISOString().replace('Z', ''),
      eventName: itemForTicket.eventName,
      isLive: itemForTicket.isLive,
      betValues: itemForTicket.betValues,
      requestedOdd: itemForTicket.requestedOdd,
      mappingType: itemForTicket.mappingType,
    };
  }

  mapBetOutcomeFromMin(minOutcome: IBetOutcomeMinTO): IBetOutcome {
    return {
      id: minOutcome.iD[0],
      sportId: minOutcome.iD[1],
      regionId: minOutcome.iD[2],
      competitionId: minOutcome.iD[3],
      eventId: minOutcome.iD[4],
      betId: minOutcome.iD[5],

      betTypeId: minOutcome.n[0],
      betTypeOutcomeId: minOutcome.n[1],
      odd: minOutcome.n[2],
      orderNo: minOutcome.n[3],
      resultStatus: minOutcome.n[4],

      // betTypeName : minOutcome.t[0],
      name: minOutcome.t[1],
      // must be set later
      sbv: null,

      isLive: !!minOutcome.b[0],
      isInOffer: !!minOutcome.b[1],
      isPlayable: !!minOutcome.b[2],
      cashBackEnabled: !!minOutcome.b[3],
      oldOdd: minOutcome.n[2]
    } as IBetOutcome;
  }

  mapBetFromMin(betMin: IBetMinTO, betTypeShowType: IBetTypeShowType): IBet {
    const betOutcomesDictionary: { [betTypeOutcomeId: number]: IBetOutcome[] } = {};
    let hasPlayableOutcomes = false;
    return {
      id: betMin.iD[0],
      sportId: betMin.iD[1],
      regionId: betMin.iD[2],
      competitionId: betMin.iD[3],
      eventId: betMin.iD[4],

      betTypeId: betMin.n[0],
      orderNo: betMin.n[1],

      outrightName: betMin.t[0],
      sbv: betMin.t[1],

      // isFinished: !!betMin.b[0],
      isMostBalanced: !!betMin.b[1],
      isLive: !!betMin.b[2],
      isInOffer: !!betMin.b[3],
      isPlayable: !!betMin.b[4],
      cashBackEnabled: !!betMin.b[5],
      // currently is always empty - for later if needed
      betOutcomes: betMin.bO.map((outcomeMin) => {
        const bo = this.mapBetOutcomeFromMin(outcomeMin);
        if (bo.isPlayable && bo.isInOffer) {
          hasPlayableOutcomes = true;
        }
        if (!betOutcomesDictionary[bo.betTypeOutcomeId]) {
          betOutcomesDictionary[bo.betTypeOutcomeId] = [];
        }
        betOutcomesDictionary[bo.betTypeOutcomeId].push(bo);
        return bo;
      }),
      betOutcomesDic: betOutcomesDictionary,
      hasPlayableOutcomes,
      useSbvHandicapPipe: betTypeShowType?.isHandicap && ViewConfigurations.useHandicapSbvPipe
    };
  }

  mapEventFromMin(
    eventMin: IEventMinTO,
    language: string,
    dateFormat: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' }): EventVM {
    const eventVm = new EventVM();
    eventVm.id = eventMin.iD[0];
    eventVm.sportId = eventMin.iD[1];
    eventVm.regionId = eventMin.iD[2];
    eventVm.competitionId = eventMin.iD[3];

    eventVm.status = eventMin.n[0];
    eventVm.betRadarEventId = eventMin.n[1];
    eventVm.betsCount = eventMin.n[2];
    eventVm.mappingType = eventMin.n[3];
    eventVm.playableBetsCount = eventMin.n[4];
    eventVm.eventType = eventMin.n[5];

    eventVm.code = eventMin.t[0];
    // later remove z
    eventVm.dateTime = eventMin.t[1] ? new Date(eventMin.t[1].replace('Z', '') + 'Z') : null;
    eventVm.eventDate = eventVm.dateTime.toLocaleDateString(language, dateFormat);
    eventVm.eventTime = eventVm.dateTime.toLocaleTimeString(language, { hour: 'numeric', minute: 'numeric' });
    eventVm.competitionName = eventMin.t[2];
    eventVm.eventName = eventMin.t[3];
    const teamsShort: string[] = eventMin.t[4].split(' - ');
    eventVm.homeTeamShort = teamsShort[0] ? teamsShort[0] : '';
    eventVm.awayTeamShort = teamsShort[1] ? teamsShort[1] : '';
    eventVm.homeTeam = eventMin.t[5] ? eventMin.t[5] : eventVm.eventName;
    eventVm.awayTeam = eventMin.t[6];

    eventVm.isLive = !!eventMin.b[0];
    eventVm.isInOffer = !!eventMin.b[1];
    eventVm.isPlayable = !!eventMin.b[2];
    eventVm.cashBackEnabled = !!eventMin.b[3];

    eventVm.betGroups = {};
    // eventMin.bT.forEach(betMin => {
    //   const bet = this.mapBetFromMin(betMin);
    //   if (!eventVm.bets[bet.betTypeId]) {
    //     eventVm.bets[bet.betTypeId] = [];
    //   }
    //   eventVm.bets[bet.betTypeId].push(bet);
    // });
    eventVm.specialOfferType = this.utilityService.getSpecialOfferType(eventVm.mappingType, eventVm.eventType);
    return eventVm;
  }

  mapEventLiveResultInfoMin(resultMin: IEventLiveResultInfoMinTO): IEventLiveResultInfo {

    return this.mapEventLiveResult({
      id: resultMin.iD[0],
      sportId: resultMin.iD[1],
      regionId: resultMin.iD[2],
      competitionId: resultMin.iD[3],

      server: resultMin.n[0],

      betStatus: resultMin.t[0],
      extMatchTime: resultMin.t[1],
      gameScore: resultMin.t[2],
      matchTime: resultMin.t[3],
      score: resultMin.t[4],
      setScore: resultMin.t[5],
      status: resultMin.t[6],
      redCards: resultMin.t[7],
      stoppageTimeAnnounced: resultMin.t[8],

      tiebreak: !!resultMin.b[0],
      isTopMinute: !!resultMin.b[1],
    });
  }

  mapCacheChanges(
    cacheMinTO: ICacheMinTO,
    expandedEventId: number,
    ticketItemGroupsInTicket: { [eventId: number]: ITicketItemGroup },
    language: string,
    dateFormatForEvent: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' },
    betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): ICacheChanges {
    const cacheChanges: ICacheChanges = {
      maxDeltaCacheNumberAsString: cacheMinTO.maxDeltaCacheNumberAsString,
      // changedSports: [],
      // changedRegions: [],
      // changedCompetitions: [],
      changedEvents: [],
      changedBets: [],
      changedBetOutcomes: [],
      changedResults: [],
      changedExpandedEvent: null,
      changedBetsForExpandedEvent: [],
      changedBetOutcomesForExpandedEvent: [],
      changedResultForExpandedEvent: null,
      changedEventsForTicket: [],
      changedBetsForTicket: [],
      changedBetOutcomesForTicket: [],
    };

    if (!cacheMinTO) {
      return cacheChanges;
    }

    for (const eventMin of cacheMinTO.changedEvents) {
      const event = this.mapEventFromMin(eventMin, language, dateFormatForEvent);
      cacheChanges.changedEvents.push(event);
      if (event.id === expandedEventId) {
        cacheChanges.changedExpandedEvent = event;
      }

      if (ticketItemGroupsInTicket[event.id]) {
        cacheChanges.changedEventsForTicket.push(event);
      }
    }

    for (const betMin of cacheMinTO.changedBets) {
      const bet = this.mapBetFromMin(betMin, betTypeShowTypes[betMin.n[0]]);
      cacheChanges.changedBets.push(bet);
      if (bet.eventId === expandedEventId) {
        cacheChanges.changedBetsForExpandedEvent.push(bet);
      }

      if (ticketItemGroupsInTicket[bet.eventId]) {
        cacheChanges.changedBetsForTicket.push(bet);
      }
    }

    for (const betOutcomeMin of cacheMinTO.changedBetOutcomes) {
      const bto = this.mapBetOutcomeFromMin(betOutcomeMin);
      cacheChanges.changedBetOutcomes.push(bto);
      if (bto.eventId === expandedEventId) {
        cacheChanges.changedBetOutcomesForExpandedEvent.push(bto);
      }

      if (ticketItemGroupsInTicket[bto.eventId] && ticketItemGroupsInTicket[bto.eventId].ticketItems[bto.id]) {
        cacheChanges.changedBetOutcomesForTicket.push(bto);
      }
    }

    for (const resultMin of cacheMinTO.changedResults) {
      const result = this.mapEventLiveResultInfoMin(resultMin);
      cacheChanges.changedResults.push(result);
      if (result.eventId === expandedEventId) {
        cacheChanges.changedResultForExpandedEvent = result;
      }
    }

    return cacheChanges;
  }


  mapBetTypeSelectionsFromTableConfig(tableConfig: ITOEventsTableConfiguration, sportId: number): IBetTypeSelection[] {
    const selections: { [betTypeId: number]: IBetTypeSelection } = {};
    let counter = 1;
    for (const columnConfig of tableConfig.columnConfigs) {
      if (!selections[columnConfig.betTypeId]) {
        selections[columnConfig.betTypeId] = {
          id: columnConfig.betTypeId,
          betProductPageId: -1,
          sportId,
          betTypeId: columnConfig.betTypeId,
          hasSBV: false,
          betTypeName: columnConfig.betTypeName,
          sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
          sbvExactValue: null,
          isSelected: false,
          orderNumber: counter,
          betTypeOutcomes: [],
          sbvDispalyType: SBVDisplayType.SBVAlone
        };
        counter++;
      }
      if (columnConfig.columnType === TOCompetitionEventsColumnType.Sbv) {
        selections[columnConfig.betTypeId].hasSBV = true;
        if (columnConfig.title === '' || !columnConfig.title) {
          selections[columnConfig.betTypeId].sbvSelectionType = BetTypeSelectionSBVSelectionType.MostBalanced;
        } else {
          selections[columnConfig.betTypeId].sbvExactValue = columnConfig.title;
          selections[columnConfig.betTypeId].sbvSelectionType = BetTypeSelectionSBVSelectionType.Exact;
        }
        continue;
      }
    }

    return Object.entries(selections).map(([k, v]) => v);
  }

  makeTicketValidationRequest(oddsValidationMode: OddsValidationMode, ticket: ITicket, authorizedTicketConfirmation: boolean, officeId: number): ITicketValidationRequestTO {

    const request: ITicketValidationRequestTO = {

      ticket: this.mapTicketTO(ticket, officeId),
      authorizedTicketConfirmation,
      oddsValidationMode,
      ticketSource: RequestSource.Web,
    };

    request.ticket.webPlatformCurrency = this.userService.user.userCurrency;
    request.ticket.webPlatformLanguage = this.userService.user.userLanguage;
    request.ticket.platformCustomerId = +this.userService.user.userName;

    // if (environment.localDeploy) {
    //   request.ticket.platformCustomerId = DeployParams.LOCAL_USER_ID;
    // }
    return request;
  }

  makeTicketConfirmationRequestTO(confirmationTicket: ITicket, officeId: number): ITicketConfirmationRequestTO {
    return {
      ticketValidationId: confirmationTicket.ticketValidationId,
      officeId,
      source: RequestSource.Web,
      webPlatformCurrency: this.userService.user.userCurrency,
      webPlatformLanguage: this.userService.user.userLanguage,
      webPlatformUsername: this.userService.user.userName
    };
  }

  mapBetOutcomeWithPlayableStatus(betOutcomeWithPlayableStatusTO: IBetOutcomeWithPlayableStatusTO, isLive: boolean): IBetOutcomeWithPlayableStatus {
    return {
      betOutcome: this.mapBetOutcome(betOutcomeWithPlayableStatusTO.betOutcome, isLive),
      isBetPlayable: betOutcomeWithPlayableStatusTO.isBetPlayable,
      isEventPlayable: betOutcomeWithPlayableStatusTO.isEventPlayable,
      eventDateTime: new Date(betOutcomeWithPlayableStatusTO.eventDateTime.replace('Z', '') + 'Z')
    };
  }

  createSrcSelectionIdsFromEventParams(isLive: boolean, sportId: number, regionId: number = null, competitionId: number = null, specialOfferType: SpecialOfferType): ISrcSelectionIds {
    return {
      sId: sportId,
      rId: regionId,
      cId: competitionId,
      isLive,
      sOT: specialOfferType
    };
  }


  mapBetsAndGroups(betsAndGroupsTO: { bets: IBetTO[]; groups: IBetTypeGroupTO[] }, isEventLive: boolean, mapOutcomes: boolean, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }): { bets: IBet[]; groups: IBetTypeGroup[] } {
    let i = 0;
    let bets = [];
    if (betsAndGroupsTO.bets) {
      bets = betsAndGroupsTO.bets.map(b => {
        i++;
        return this.mapBet(b, i, isEventLive, mapOutcomes, betTypeShowTypes[b.betTypeId]);
      });
    }
    return { bets, groups: betsAndGroupsTO.groups ? betsAndGroupsTO.groups.map((g) => this.mapBetTypeGroup(g, betTypeShowTypes)) : [] };
  }

  specialSportTOToRegion(sport: ISportTO, orderNo: number): IRegion {
    return {
      id: sport.id,
      sportId: sport.id,
      eventsCount: sport.eventsCount,
      name: sport.name,
      isSelected: false,
      orderNo,
    } as IRegion;
  }

  specialSportToRegion(sport: ISport, orderNo: number): IRegion {
    return {
      id: sport.id,
      sportId: sport.id,
      eventsCount: sport.eventsCount,
      name: sport.name,
      isSelected: false,
      orderNo,
    } as IRegion;
  }

  public mapFcmSubcriptionForEvent(userId: number, token: string, event: EventVM): FcmSubscriptionRequestTO {
    const eventKeyTemp: EventKeyTO = {
      competitionId: event.competitionId,
      eventId: event.id,
      regionId: event.regionId,
      sportId: event.sportId,
      isLive: event.isLive
    };
    return {
      userId,
      fCMToken: token,
      isSubscribed: event.isNotificationEnabled,
      events: [eventKeyTemp]
    } as FcmSubscriptionRequestTO;
  }

  public mapFcmSubcriptionForTicketItemGroup(userId: number, token: string, isSubscribed: boolean, ticketItemGroups: ITicketItemGroup[]): FcmSubscriptionRequestTO {

    const eventsKeyList: EventKeyTO[] = [];

    for (const ticketItemGroup of ticketItemGroups) {
      const eventKeyTemp: EventKeyTO = {
        competitionId: -1,
        eventId: -1,
        regionId: -1,
        sportId: -1,
        isLive: false
      };

      eventKeyTemp.competitionId = ticketItemGroup.competitionId;
      eventKeyTemp.sportId = ticketItemGroup.sportId;
      eventKeyTemp.regionId = ticketItemGroup.regionId;
      eventKeyTemp.eventId = ticketItemGroup.eventId;
      eventKeyTemp.isLive = ticketItemGroup.isLive;
      eventsKeyList.push(eventKeyTemp);
    }

    return {
      userId,
      fCMToken: token,
      isSubscribed,
      events: eventsKeyList
    } as FcmSubscriptionRequestTO;
  }

  public mapOddSheet(oddSheetTO: IOddSheetTO, dateString: string): IOddSheet {
    return {
      fileName: oddSheetTO.fName,
      name: oddSheetTO.name,
      dateString
    };
  }

  public mapDailyOddSheets(dailyOddSheetsTO: IDailyOddSheetsTO, languageCulture: string, useAllInOne: boolean = false, dateFormat: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit' }): IDailyOddSheets {
    const dateString: string = dailyOddSheetsTO.date ? new Date(dailyOddSheetsTO.date.replace('Z', '') + 'Z').toLocaleDateString(languageCulture, dateFormat) : new Date().toLocaleDateString(languageCulture, dateFormat);
    return {
      dateString,
      oddSheets: dailyOddSheetsTO.oddSheets.map(osTO => this.mapOddSheet(osTO, useAllInOne ? dateString : '')),
      isSelected: false,
      oddSheetsCount: dailyOddSheetsTO.oddSheets.length
    };
  }

  public mapOddSheets(oddSheetsTO: IOddSheetsTO, languageCulture: string): IOddSheets {
    if (!oddSheetsTO) {
      return {
        mainList: null,
        dailyLists: null
      };
    }
    let mainList: IOddSheet;
    if (oddSheetsTO.mainList) {
      mainList = this.mapOddSheet(oddSheetsTO.mainList, '');
    }

    const subListOddSheetsTO: IOddSheetTO[] = [];
    if (oddSheetsTO.subLists) {
      for (const subList of oddSheetsTO.subLists) {
        subList.oddSheets.map(odsTO => subListOddSheetsTO.push(odsTO));
      }
    }

    return {
      mainList,
      dailyLists: this.mapDailyOddSheets({ date: null, oddSheetsCount: subListOddSheetsTO.length, oddSheets: subListOddSheetsTO }, languageCulture, true)
    };
  }

  mapResults(webScoresTO: IWebScoreTO[]): { [groupId: number]: IGroupResult } {
    const results: { [groupId: number]: IGroupResult } = {};
    for (const webScore of webScoresTO) {
      if (!results[webScore.scoreGroupId]) {
        results[webScore.scoreGroupId] = {
          hasHomeAway: false,
          scorePeriods: [],
          scoreGroupId: webScore.scoreGroupId
        };
      }

      if (webScore.homeAway) {
        results[webScore.scoreGroupId].hasHomeAway = true;
      }

      let scorePeriod = results[webScore.scoreGroupId].scorePeriods.find(s => s.periodNumber === webScore.periodNumber);

      if (!scorePeriod) {
        scorePeriod = {
          homeAwayValue: {},
          periodNumber: webScore.periodNumber
        };
        results[webScore.scoreGroupId].scorePeriods.push(scorePeriod);
      }

      const homeAwayEnum: HomeAway = webScore.homeAway ? webScore.homeAway as unknown as HomeAway : HomeAway.NONE;

      scorePeriod.homeAwayValue[homeAwayEnum] = webScore.value;

    }
    return results;
  }

  mapTicketEventResults(ticketItemWebScoresTO: ITicketItemWebScoreTO[]): ITicketResultGroup[] {
    const results: { [groupId: number]: ITicketResultGroup } = {};
    for (const webScore of ticketItemWebScoresTO) {
      if (!results[webScore.scoreGroupId]) {
        results[webScore.scoreGroupId] = {
          hasHomeAway: false,
          scorePeriods: [],
          scoreGroupId: webScore.scoreGroupId,
          scoreGroupName: webScore.scoreGroupName
        };
      }

      if (webScore.homeAway) {
        results[webScore.scoreGroupId].hasHomeAway = true;
      }

      let scorePeriod = results[webScore.scoreGroupId].scorePeriods.find(s => s.periodNumber === webScore.periodNumber);

      if (!scorePeriod) {
        scorePeriod = {
          homeAwayValue: {},
          periodNumber: webScore.periodNumber
        };
        results[webScore.scoreGroupId].scorePeriods.push(scorePeriod);
      }

      const homeAwayEnum: HomeAway = webScore.homeAway ? webScore.homeAway as unknown as HomeAway : HomeAway.NONE;

      scorePeriod.homeAwayValue[homeAwayEnum] = webScore.value;

    }
    return Object.entries(results).map(([k, v]) => v);
  }

  mapScoreGroup(scoreGroupTo: IScoreGroup): IScoreGroup {
    return {
      id: scoreGroupTo.id,
      name: scoreGroupTo.name
    };
  }

  mapEventResult(eventResultTO: IWebEventResultTO, sportName: string, regionName: string, competitionName: string, languageCulture: string): IEventResult {
    const teams: string[] = eventResultTO.eventName.split(' - ');
    const teamsShort: string[] = eventResultTO.eventShortName ? eventResultTO.eventShortName.split(' - ') : [];
    const dateTime: Date = new Date(eventResultTO.eventTime.replace('Z', '') + 'Z');
    return {
      eventId: eventResultTO.eventId,
      eventCode: eventResultTO.eventCode,
      eventDateTime: dateTime,
      competitionId: eventResultTO.competitionId,
      regionId: eventResultTO.regionId,
      sportId: eventResultTO.sportId,
      competitionName,
      eventName: eventResultTO.eventName,
      betGroups: {},
      homeTeam: teams[0] ? teams[0] : '',
      awayTeam: teams[1] ? teams[1] : '',
      homeTeamShort: teamsShort[0] ? teamsShort[0] : '',
      awayTeamShort: teamsShort[1] ? teamsShort[1] : '',
      // betsCount: eventResultTO.betsCount,
      results: this.mapResults(eventResultTO.scores),
      regionName,
      sportName,
      // eventType: eventResultTO.eventType,
      isExpanded: false,
      eventDate: dateTime.toLocaleDateString(languageCulture, { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit' }),
      eventTime: dateTime.toLocaleTimeString(languageCulture, { hour: 'numeric', minute: 'numeric' }),
      eventType: EventType.HeadToHead
    };
  }

  mapEvenResultsAndScoreGroups(webEventResultsResponse: IWebEventResultsResponseTO, languageCulture: string, sport: ISport, region?: IRegion, competition?: ICompetition): IEvenResultsAndScoreGroups {
    const eventResults: IEventResult[] = [];
    for (const eventResultTo of webEventResultsResponse.eventResults) {
      let regionName = '';
      let competitionName = '';
      if (region) {
        regionName = region.name;
        if (competition) {
          competitionName = competition.name;
        } else {
          const cmp = region.competitions.find(c => c.id === eventResultTo.competitionId);
          competitionName = cmp ? cmp.name : '';
        }
      } else {
        const reg = sport.regions.find(r => r.id === eventResultTo.regionId);
        regionName = reg ? reg.name : '';
        if (reg) {
          const cmp = reg.competitions.find(c => c.id === eventResultTo.competitionId);
          competitionName = cmp ? cmp.name : '';
        }
      }
      eventResults.push(this.mapEventResult(eventResultTo, sport.name, regionName, competitionName, languageCulture));
    }
    return {
      eventResults,
      scoreGroups: webEventResultsResponse.groups.map(sg => this.mapScoreGroup(sg)),
    };
  }

  mapOtcomeCodeValues(outcomeCodeValues: IOutcomeCodeValueTO[]): IOutcomeCodeValue[] {
    // const ocvDictionary: { [betTypeId: number]: { [betTypeOutcomeId: number]: IOutcomeCodeValue[] } } = {};
    // for (const ocv of outcomeCodeValues) {
    //   if (!ocvDictionary[ocv.betTypeId]) {
    //     ocvDictionary[ocv.betTypeId] = {};
    //   }

    //   if (!ocvDictionary[ocv.betTypeId][ocv.betTypeOutcomeId]) {
    //     ocvDictionary[ocv.betTypeId][ocv.betTypeOutcomeId] = [];
    //   }

    //   ocvDictionary[ocv.betTypeId][ocv.betTypeOutcomeId].push(ocv);
    // }

    return outcomeCodeValues.map(ocvTO => this.mapOutcomeCodeValue(ocvTO));
  }

  mapOutcomeCodeValue(outcomeCodeValueTO: IOutcomeCodeValueTO): IOutcomeCodeValue {
    return {
      id: outcomeCodeValueTO.id,
      betTypeOutcomeId: outcomeCodeValueTO.betTypeOutcomeId,
      code: outcomeCodeValueTO.code,
      value: outcomeCodeValueTO.value,
      betTypeCode: outcomeCodeValueTO.betTypeCode,
      outcomeCode: outcomeCodeValueTO.outcomeCode,
      ticketPrintName: outcomeCodeValueTO.ticketPrintName,
      betTypeId: outcomeCodeValueTO.betTypeId,
    };
  }

  mapTicketPrint(ticket: ITicket): ITicketPrintViewModel {
    if (!ticket) {
      return null;
    }
    const ticketPrint: ITicketPrintViewModel = {
      officeId: ticket.officeId,
      bonus: ticket.bonus,
      minBonus: ticket.minBonus,
      bonusPercent: ticket.bonusPercent,
      ticketItemGroups: [],
      id: ticket.id,
      isLive: ticket.isLive,
      itemsNumber: ticket.itemsNumber,
      maxPayout: ticket.maxPayout,
      numOfCombinations: ticket.numOfCombinations,
      pinCode: ticket.pinCode,
      possibleWin: ticket.possibleWin,
      possibleWinWithoutBonus: ticket.possibleWinWithoutBonus,
      taxBeforeStake: ticket.taxBeforeStake,
      taxBeforeStakePercent: ticket.taxBeforeStakePercent,
      taxOnWinning: ticket.taxOnWinning,
      ticketDescription: ticket.ticketDescription,
      ticketId: ticket.ticketId,
      totalOdd: ticket.totalOdd,
      totalStake: ticket.totalStake,
      typeOfTicket: ticket.typeOfTicket,
      updatedDateTime: ticket.updatedDateTime,
      winOdds: ticket.winOdds,
      eventsCount: ticket.eventsCount,
      webPlatformCurrency: ticket.webPlatformCurrency,
      webPlatformLanguage: ticket.webPlatformLanguage,
      isFastTicket: ticket.isFastTicket,
      minOdd: ticket.minOdd,
      minWinings: ticket.minWinings,
      isFreeBet: ticket.isFreeBet,
      freeBetValue: ticket.freeBetValue,
      ticketTypeName: ticket.ticketTypeName,
      systemName: ticket.systemName,
      payin: ticket.payin,
      possibleWinWithoutTax: ticket.possibleWinWithoutTax,
      possiblePayout: ticket.possiblePayout,
      possibleMinPayout: ticket.possibleMinPayout,
      taxOnMinWinning: ticket.taxOnMinWinning,
      fixItemsCount: 0,
      systemItemsCount: 0,
      systems: []
    };

    for (const group of ticket.groups) {
      if (group.groupType === TicketType.Fix || group.groupType === TicketType.Single) {
        ticketPrint.fixItemsCount = group.n;
      } else {
        ticketPrint.systemItemsCount = group.n;
        const systemsS: string[] = group.k.split(';');
        ticketPrint.systems = systemsS.map(s => +(s.trim()));
      }

      for (const [boId, ticketItem] of Object.entries(group.ticketItems)) {
        let eventGroup = ticketPrint.ticketItemGroups.find(g => g.eventId === ticketItem.eventId);

        if (!eventGroup) {
          eventGroup = this.createItemGroupPrintFromTicketItem(ticketItem, group.groupType, ticket.groups.length > 0 ? true : false);
          ticketPrint.ticketItemGroups.push(eventGroup);
        }

        let sbv: any;
        if (ticketItem.sbv) {
          sbv = ticketItem.sbv;
        } else if (ticketItem.betValues && ticketItem.betValues.length !== 0) {
          if (ticketItem.betValues[0].value != null) {
            sbv = ticketItem.betValues[0].value;
          } else if (ticketItem.betValues[0].liveSpecialBetValue != null) {
            sbv = ticketItem.betValues[0].liveSpecialBetValue;
          } else {
            sbv = null;
          }
        } else {
          sbv = null;
        }

        eventGroup.ticketItems.push(
          {
            sbv,
            odd: ticketItem.acceptedOdd,
            betTypeName: ticketItem.betTypeName,
            betTypeOutcomeName: ticketItem.betTypeOutcomeName,
            isLive: ticketItem.isLive,
          }
        );
      }

      ticketPrint.ticketItemGroups = this.utilityService.sortTicketItemGroupsPrintByDateAndCode(ticketPrint.ticketItemGroups);

    }

    return ticketPrint;
  }

  public createItemGroupPrintFromTicketItem(ticketItem: ITicketItemForTicket, groupType: TicketType, isSystemTicket: boolean): ITicketItemGroupPrintViewModel {
    return {
      eventId: ticketItem.eventId,
      sportName: ticketItem.sportName,
      regionName: ticketItem.regionName,
      competitionName: ticketItem.competitionName,
      eventName: ticketItem.eventName,
      eventCode: ticketItem.eventCode,
      eventDateTime: ticketItem.eventDateTime,
      mappingType: ticketItem.mappingType,
      isInBankersGroup: groupType === TicketType.Fix && isSystemTicket,
      ticketItems: [],
      isLive: ticketItem.isLive,
    };
  }

  mapBetTypeGroupingTemplateItem(item: IBetTypeGroupingTemplateItemTO, betTypeShowType: IBetTypeShowType = null): IBetTypeGroupingTemplateItem {
    const btgti: IBetTypeGroupingTemplateItem = {
      betTypeId: item.betTypeId,
      groupId: item.groupId,
      id: item.id,
      orderNumber: item.orderNumber,
      sbvExactValue: item.sBVExactValue,
      sbvSelectionType: item.sBVSelectionType,
      betTypeName: betTypeShowType ? betTypeShowType.betTypeName : null,
      betTypeOutcomes: [],
      sbvDisplayType: betTypeShowType ? betTypeShowType.sbvDisplayType : SBVDisplayType.NoSbv,
      betTypeDescription: betTypeShowType ? betTypeShowType.betTypeDescription : '',
      betTypeOutcomeGroupingTemplateItems: [],
      isSelected: false
    };

    if (item.tOTBetTypeOutcomeGroupingTemplateItems) {
      for (const btogtiTO of item.tOTBetTypeOutcomeGroupingTemplateItems) {
        const btogti = this.mapBetTypeOutcomeGroupingTemplateItem(btogtiTO);
        btgti.betTypeOutcomeGroupingTemplateItems.push(btogti);
        if (!betTypeShowType) {
          continue;
        }

        const bto = betTypeShowType.betTypeOutcomes ? betTypeShowType.betTypeOutcomes[btogti.betTypeOutcomeId] : null;
        if (bto) {
          btgti.betTypeOutcomes.push({
            id: bto.id,
            name: bto.name,
            shortName: bto.shortName,
            orderNumber: bto.orderNumber,
            betTypeId: bto.betTypeId,
            terminalShowType: bto.terminalShowType,
            desktopShowType: bto.desktopShowType,
            mobileShowType: bto.mobileShowType,
            customName: bto.customName,
            descriptions: bto.descriptions,
            btoIncludedInSelectionOrGroup: btogtiTO.includedInGroup,
            btoVisibilityTypeId: btogtiTO.visibilityTypeId,
            isFreeText: bto.isFreeText,
            isSelected: false
          });
        }
      }

    } else {
      btgti.betTypeOutcomes = betTypeShowType ? betTypeShowType.betTypeOutcomesList : null;
    }

    btgti.betTypeOutcomes = this.utilityService.sortByOrderNumber(btgti.betTypeOutcomes);
    return btgti;
  }

  public mapBetTypeOutcomeGroupingTemplateItem(betTypeOutcomeGroupingTemplateItemTO: IBetTypeOutcomeGroupingTemplateItemTO): IBetTypeOutcomeGroupingTemplateItem {
    return {
      betTypeId: betTypeOutcomeGroupingTemplateItemTO.tBetTypeGroupingTemplateItemId,
      betTypeOutcomeId: betTypeOutcomeGroupingTemplateItemTO.betTypeOutcomeId,
      includedInGroup: betTypeOutcomeGroupingTemplateItemTO.includedInGroup,
      betTypeGroupingTemplateItemId: betTypeOutcomeGroupingTemplateItemTO.tBetTypeGroupingTemplateItemId,
      visibilityTypeId: betTypeOutcomeGroupingTemplateItemTO.visibilityTypeId,
    };
  }
}

